/* SePRO PondWise Planner — Shopify build
   Generated 2026-08-24 14:56 UTC from src/. Do not edit this file directly; edit the
   sources and re-run build_shopify.py. */


/* ==== 00-util.js ==== */
/* ============================================================
   PW — SePRO PondWise Planner (proof of concept)
   Modular namespaces so each piece can be lifted into its own file / service
   later without rewriting the calculator:
     PW.geo    pond geometry + treatment-zone solver
     PW.dose   product data model + dosage engine
     PW.store  persistence, accounts, roles   (swap for an API later)
     PW.ui     views
   ============================================================ */
var PW = window.PW || {};
PW.VERSION = '2.0.0-poc';
PW.BUILD = '2026-08-24 14:56 UTC';

PW.util = (function () {
  'use strict';

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v == null || v === false) return;
      if (k === 'class') n.className = v;
      else if (k === 'html') n.innerHTML = v;
      else if (k === 'text') n.textContent = v;
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2).toLowerCase(), v);
      else if (k === 'dataset') Object.keys(v).forEach(function (d) { n.dataset[d] = v[d]; });
      else n.setAttribute(k, v === true ? '' : v);
    });
    (kids || []).forEach(function (c) {
      if (c == null || c === false) return;
      n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return n;
  }

  /**
   * cls('note', kind) -> 'pw-note pw-err'
   * Every class the planner renders is namespaced, so a host theme that also
   * defines .card, .btn or .note cannot reach into the planner and the planner
   * cannot reach out. Use this wherever a class is built at runtime.
   */
  function cls() {
    var out = [];
    for (var i = 0; i < arguments.length; i++) {
      String(arguments[i] == null ? '' : arguments[i]).split(/\s+/).forEach(function (t) {
        if (!t) return;
        out.push(t.indexOf('pw-') === 0 ? t : 'pw-' + t);
      });
    }
    return out.join(' ');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function n0(v) { var x = Math.round(Number(v) || 0); return x.toLocaleString(); }
  function n2(v) { return (Number(v) || 0).toFixed(2); }
  function n1(v) { return (Number(v) || 0).toFixed(1); }

  function uid(p) {
    return (p || 'id') + '-' + Math.random().toString(36).slice(2, 9) + '-' + Date.now().toString(36);
  }

  function today() {
    var d = new Date();
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function prettyDate(iso) {
    if (!iso) return '—';
    var p = String(iso).slice(0, 10).split('-');
    if (p.length < 3) return iso;
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[+p[1] - 1] + ' ' + (+p[2]) + ', ' + p[0];
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, a); }, ms || 180);
    };
  }

  function clear(node) { while (node.firstChild) node.removeChild(node.firstChild); return node; }

  /* -------- tooltip glossary -------- */
  var GLOSSARY = {
    'surface acre': 'One acre of water surface — 43,560 square feet — measured looking straight down, no matter how deep the water is. Product rates written "per surface acre" ignore depth entirely.',
    'acre-foot': 'The volume of one surface acre of water one foot deep: about 325,851 gallons. A one-acre pond averaging 4 feet deep holds 4 acre-feet. Rates written "per acre-foot" scale with depth, so depth accuracy matters.',
    'average depth': 'The average water depth across the area being treated, not the deepest spot. For an evenly bowl-shaped pond, roughly half the maximum depth is a reasonable estimate. Measure in several places and average them.',
    'treatment zone': 'The part of the pond you actually intend to treat. Here it is the band of water within your entered growth distance of the mapped shoreline, measured inward, and it can never extend past the pond boundary.',
    'shoreline growth distance': 'How far aquatic growth extends from the shoreline toward the middle of the pond, in feet, averaged around the pond. Walk or look around the shoreline and estimate a typical distance rather than the worst spot.',
    'application rate': 'The amount of product the label directs per unit of what you measured — per surface acre, per acre-foot, per 1,000 square feet, or as a target concentration in the water. Labels usually give a range; the low end suits light early-season growth and the high end dense, mature growth.',
    'ppm': 'Parts per million — a concentration in the water. For copper products, 1.0 ppm metallic copper is the single-application ceiling on every SePRO copper label in this tool.',
    'ppb': 'Parts per billion — the concentration basis used by fluridone products (the Sonar family) and by Clearcast. One thousand ppb equals 1 ppm.',
    'acid equivalent': 'Abbreviated "a.e." — the weight of the active herbicide acid itself, separate from the salt or ester it is formulated as. Labels cap the a.e. applied, which is why product amount and a.e. amount differ.',
    'treatment-zone volume': 'The treatment zone surface area multiplied by the depth being treated. This is what per-acre-foot and concentration-based rates are applied to.',
    'plant growth height': 'For a few granular products the label sets the rate by how tall the target plants stand in the water column — bottom to top of the plants — rather than by water depth.'
  };

  function tip(term, textOverride) {
    var t = textOverride || GLOSSARY[String(term).toLowerCase()] || '';
    return '<span class="pw-tip" tabindex="0" data-tip="' + esc(t) + '">' + esc(term) + '<sup>?</sup></span>';
  }

  return {
    el: el, esc: esc, cls: cls, n0: n0, n1: n1, n2: n2, uid: uid, today: today,
    prettyDate: prettyDate, debounce: debounce, clear: clear,
    tip: tip, GLOSSARY: GLOSSARY
  };
})();


/* ==== 10-geo.js ==== */
/* ============================================================
   PW.geo — pond geometry and the inward shoreline treatment zone
   ------------------------------------------------------------
   The treatment zone is the band of water within D feet of the mapped
   shoreline, measured inward. It is computed from a signed distance field
   rather than a naive perimeter x distance product, so it is correct for
   concave shorelines, narrow arms and small ponds, and it can never spill
   outside the mapped boundary.

   Method (shown to the user, verbatim, in the report):
     1. Project the mapped vertices to a local plane in feet.
     2. Lay a uniform grid over the polygon (target ~240 cells across the
        longer side, clamped to a 40..320 range).
     3. For every cell centre, test point-in-polygon and measure the
        shortest distance to any shoreline segment.
     4. Cells inside the polygon whose distance is <= D are treatment zone;
        the rest of the interior is the untreated core.
     5. Scale both cell counts so they sum to the true spherical surface
        area of the polygon, which removes the grid's discretisation bias.
     6. Trace the D-foot contour with marching squares to draw the inner
        edge of the zone on the map.
   ============================================================ */
PW.geo = (function () {
  'use strict';

  var SQFT_PER_SQM = 10.76391041671;
  var FT_PER_M = 3.280839895;
  var SQFT_PER_ACRE = 43560;
  var GAL_PER_ACREFT = 325851.4;

  /* ---------- basic measures (spherical, via the Maps geometry library) ---------- */

  function ring(path) {
    // path: array of {lat,lng}
    return path.map(function (p) { return new google.maps.LatLng(p.lat, p.lng); });
  }

  function areaSqft(path) {
    if (!path || path.length < 3) return 0;
    return Math.abs(google.maps.geometry.spherical.computeArea(ring(path))) * SQFT_PER_SQM;
  }

  function perimeterFt(path) {
    if (!path || path.length < 3) return 0;
    var r = ring(path);
    r.push(r[0]);
    return google.maps.geometry.spherical.computeLength(r) * FT_PER_M;
  }

  function centroid(path) {
    var la = 0, ln = 0;
    path.forEach(function (p) { la += p.lat; ln += p.lng; });
    return { lat: la / path.length, lng: ln / path.length };
  }

  /* ---------- local planar projection, in feet ---------- */

  function projector(path) {
    var c = centroid(path);
    var mPerDegLat = 111132.92 - 559.82 * Math.cos(2 * c.lat * Math.PI / 180);
    var mPerDegLng = 111412.84 * Math.cos(c.lat * Math.PI / 180);
    return {
      origin: c,
      to: function (p) {
        return {
          x: (p.lng - c.lng) * mPerDegLng * FT_PER_M,
          y: (p.lat - c.lat) * mPerDegLat * FT_PER_M
        };
      },
      from: function (q) {
        return {
          lat: c.lat + (q.y / FT_PER_M) / mPerDegLat,
          lng: c.lng + (q.x / FT_PER_M) / mPerDegLng
        };
      }
    };
  }

  /* ---------- point in polygon (ray casting) ---------- */

  function inside(pts, x, y) {
    var n = pts.length, hit = false;
    for (var i = 0, j = n - 1; i < n; j = i++) {
      var xi = pts[i].x, yi = pts[i].y, xj = pts[j].x, yj = pts[j].y;
      if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) hit = !hit;
    }
    return hit;
  }

  /* ---------- distance from a point to the polygon boundary ---------- */

  function distToEdges(pts, x, y) {
    var best = Infinity, n = pts.length;
    for (var i = 0, j = n - 1; i < n; j = i++) {
      var ax = pts[j].x, ay = pts[j].y, bx = pts[i].x, by = pts[i].y;
      var dx = bx - ax, dy = by - ay;
      var L2 = dx * dx + dy * dy;
      var t = L2 === 0 ? 0 : ((x - ax) * dx + (y - ay) * dy) / L2;
      t = t < 0 ? 0 : (t > 1 ? 1 : t);
      var px = ax + t * dx - x, py = ay + t * dy - y;
      var d2 = px * px + py * py;
      if (d2 < best) best = d2;
    }
    return Math.sqrt(best);
  }

  /* ---------- self-intersection check (for validation) ---------- */

  function segsCross(p1, p2, p3, p4) {
    function o(a, b, c) {
      var v = (b.y - a.y) * (c.x - b.x) - (b.x - a.x) * (c.y - b.y);
      return v > 1e-9 ? 1 : (v < -1e-9 ? 2 : 0);
    }
    var o1 = o(p1, p2, p3), o2 = o(p1, p2, p4), o3 = o(p3, p4, p1), o4 = o(p3, p4, p2);
    return o1 !== o2 && o3 !== o4;
  }

  function selfIntersects(pts) {
    var n = pts.length;
    if (n < 4) return false;
    for (var i = 0; i < n; i++) {
      for (var j = i + 1; j < n; j++) {
        if (i === j) continue;
        // skip adjacent / shared-vertex pairs
        if (j === i + 1 || (i === 0 && j === n - 1)) continue;
        var a1 = pts[i], a2 = pts[(i + 1) % n], b1 = pts[j], b2 = pts[(j + 1) % n];
        if (segsCross(a1, a2, b1, b2)) return true;
      }
    }
    return false;
  }

  /* ---------- duplicate / near-duplicate vertices ---------- */

  function duplicateVertices(pts, tolFt) {
    tolFt = tolFt || 1.0;
    var out = [];
    for (var i = 0; i < pts.length; i++) {
      for (var j = i + 1; j < pts.length; j++) {
        var dx = pts[i].x - pts[j].x, dy = pts[i].y - pts[j].y;
        if (Math.sqrt(dx * dx + dy * dy) < tolFt) out.push([i, j]);
      }
    }
    return out;
  }

  /* ---------- marching squares contour at a given distance level ---------- */

  function contours(field, nx, ny, x0, y0, cell, level) {
    // field[iy*nx+ix] holds signed distance: positive inside, negative outside.
    var segs = [];
    function V(ix, iy) { return field[iy * nx + ix]; }
    function ip(v1, v2, a, b) {
      var t = (level - v1) / (v2 - v1);
      return { x: a.x + (b.x - a.x) * t, y: a.y + (b.y - a.y) * t };
    }
    for (var iy = 0; iy < ny - 1; iy++) {
      for (var ix = 0; ix < nx - 1; ix++) {
        var v0 = V(ix, iy), v1 = V(ix + 1, iy), v2 = V(ix + 1, iy + 1), v3 = V(ix, iy + 1);
        var p0 = { x: x0 + ix * cell, y: y0 + iy * cell };
        var p1 = { x: p0.x + cell, y: p0.y };
        var p2 = { x: p0.x + cell, y: p0.y + cell };
        var p3 = { x: p0.x, y: p0.y + cell };
        var idx = (v0 >= level ? 1 : 0) | (v1 >= level ? 2 : 0) | (v2 >= level ? 4 : 0) | (v3 >= level ? 8 : 0);
        if (idx === 0 || idx === 15) continue;
        var bottom = function () { return ip(v0, v1, p0, p1); };
        var right = function () { return ip(v1, v2, p1, p2); };
        var top = function () { return ip(v3, v2, p3, p2); };
        var left = function () { return ip(v0, v3, p0, p3); };
        switch (idx) {
          case 1: case 14: segs.push([left(), bottom()]); break;
          case 2: case 13: segs.push([bottom(), right()]); break;
          case 3: case 12: segs.push([left(), right()]); break;
          case 4: case 11: segs.push([right(), top()]); break;
          case 6: case 9: segs.push([bottom(), top()]); break;
          case 7: case 8: segs.push([left(), top()]); break;
          case 5: segs.push([left(), bottom()]); segs.push([right(), top()]); break;
          case 10: segs.push([left(), top()]); segs.push([bottom(), right()]); break;
        }
      }
    }
    return stitch(segs, cell * 0.6);
  }

  function stitch(segs, tol) {
    var rings = [], used = new Array(segs.length).fill(false);
    function near(a, b) {
      return Math.abs(a.x - b.x) < tol && Math.abs(a.y - b.y) < tol;
    }
    for (var s = 0; s < segs.length; s++) {
      if (used[s]) continue;
      used[s] = true;
      var line = [segs[s][0], segs[s][1]];
      var grew = true, guard = 0;
      while (grew && guard++ < 20000) {
        grew = false;
        for (var k = 0; k < segs.length; k++) {
          if (used[k]) continue;
          var a = segs[k][0], b = segs[k][1];
          var head = line[0], tail = line[line.length - 1];
          if (near(tail, a)) { line.push(b); used[k] = true; grew = true; }
          else if (near(tail, b)) { line.push(a); used[k] = true; grew = true; }
          else if (near(head, b)) { line.unshift(a); used[k] = true; grew = true; }
          else if (near(head, a)) { line.unshift(b); used[k] = true; grew = true; }
        }
      }
      if (line.length >= 4) rings.push(line);
    }
    return rings;
  }

  function polyAreaFt2(pts) {
    var a = 0, n = pts.length;
    for (var i = 0, j = n - 1; i < n; j = i++) {
      a += pts[j].x * pts[i].y - pts[i].x * pts[j].y;
    }
    return Math.abs(a) / 2;
  }

  /* ---------- the main entry point ---------- */

  /**
   * measure(path, opts)
   *   path : [{lat,lng}, ...] mapped shoreline, at least 3 vertices
   *   opts : { growthFt }
   * Returns pond measures plus the treatment-zone solution.
   */
  function measure(path, opts) {
    opts = opts || {};
    var out = {
      valid: false, vertices: path ? path.length : 0,
      pondSqft: 0, pondAcres: 0, perimeterFt: 0,
      zoneSqft: 0, zoneAcres: 0, zonePct: 0, coreSqft: 0,
      maxInscribedFt: 0, rings: [], wholePond: false,
      naiveZoneSqft: 0, gridCells: 0, cellFt: 0, issues: []
    };
    if (!path || path.length < 3) { out.issues.push('incomplete'); return out; }

    var proj = projector(path);
    var pts = path.map(proj.to);

    if (selfIntersects(pts)) out.issues.push('self_intersect');
    if (duplicateVertices(pts).length) out.issues.push('duplicate_points');

    out.pondSqft = areaSqft(path);
    out.perimeterFt = perimeterFt(path);
    out.pondAcres = out.pondSqft / SQFT_PER_ACRE;
    out.valid = out.pondSqft > 0;
    if (!out.valid) { out.issues.push('zero_area'); return out; }

    var growth = Math.max(0, Number(opts.growthFt) || 0);
    out.naiveZoneSqft = Math.min(out.perimeterFt * growth, out.pondSqft);

    // ---- grid ----
    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    pts.forEach(function (p) {
      if (p.x < minX) minX = p.x; if (p.x > maxX) maxX = p.x;
      if (p.y < minY) minY = p.y; if (p.y > maxY) maxY = p.y;
    });
    var w = maxX - minX, h = maxY - minY;
    var span = Math.max(w, h);
    var target = 240;
    var cell = span / target;
    // keep the grid within sane bounds for both tiny and large ponds
    var nx = Math.min(320, Math.max(40, Math.ceil(w / cell) + 3));
    var ny = Math.min(320, Math.max(40, Math.ceil(h / cell) + 3));
    cell = Math.max(w / (nx - 3), h / (ny - 3));
    var x0 = minX - 1.5 * cell, y0 = minY - 1.5 * cell;
    out.cellFt = cell;
    out.gridCells = nx * ny;

    // ---- signed distance field ----
    var field = new Float64Array(nx * ny);
    var inCount = 0, zoneCount = 0, maxDist = 0;
    for (var iy = 0; iy < ny; iy++) {
      var py = y0 + iy * cell;
      for (var ix = 0; ix < nx; ix++) {
        var px = x0 + ix * cell;
        var d = distToEdges(pts, px, py);
        var isIn = inside(pts, px, py);
        field[iy * nx + ix] = isIn ? d : -d;
        if (isIn) {
          inCount++;
          if (d > maxDist) maxDist = d;
          if (d <= growth) zoneCount++;
        }
      }
    }
    out.maxInscribedFt = maxDist;

    if (inCount === 0) {
      // polygon narrower than one grid cell — fall back to the documented estimate
      out.issues.push('too_small_for_grid');
      out.zoneSqft = out.naiveZoneSqft;
      out.method = 'perimeter_estimate';
    } else {
      // Calibrate the cell counts against the true spherical area so the grid's
      // discretisation error cancels out.
      var scale = out.pondSqft / (inCount * cell * cell);
      out.zoneSqft = zoneCount * cell * cell * scale;
      out.coreSqft = Math.max(0, out.pondSqft - out.zoneSqft);
      out.method = 'inward_buffer_distance_field';
    }

    if (growth <= 0) {
      out.zoneSqft = 0; out.coreSqft = out.pondSqft; out.rings = [];
    } else if (growth >= maxDist) {
      out.wholePond = true;
      out.zoneSqft = out.pondSqft;
      out.coreSqft = 0;
      out.rings = [];
      out.issues.push('zone_covers_pond');
    } else if (out.method === 'inward_buffer_distance_field') {
      var ringsFt = contours(field, nx, ny, x0, y0, cell, growth);
      // drop specks and anything that leaked outside the polygon
      out.rings = ringsFt
        .filter(function (r) { return polyAreaFt2(r) > (cell * cell * 4); })
        .map(function (r) { return r.map(proj.from); });
      // The zone can never extend past the boundary: the field is only >= growth
      // strictly inside, so the contour is inside by construction. Assert it.
      out.zoneSqft = Math.min(out.zoneSqft, out.pondSqft);
      out.coreSqft = Math.max(0, out.pondSqft - out.zoneSqft);
    }

    out.zoneAcres = out.zoneSqft / SQFT_PER_ACRE;
    out.zonePct = out.pondSqft > 0 ? (out.zoneSqft / out.pondSqft) * 100 : 0;
    out.proj = proj;
    return out;
  }

  function acreFeet(acres, depthFt) { return (Number(acres) || 0) * (Number(depthFt) || 0); }
  function gallons(acreFt) { return (Number(acreFt) || 0) * GAL_PER_ACREFT; }

  return {
    measure: measure,
    areaSqft: areaSqft,
    perimeterFt: perimeterFt,
    acreFeet: acreFeet,
    gallons: gallons,
    SQFT_PER_ACRE: SQFT_PER_ACRE,
    GAL_PER_ACREFT: GAL_PER_ACREFT,
    _internal: { projector: projector, inside: inside, distToEdges: distToEdges, contours: contours, selfIntersects: selfIntersects }
  };
})();


/* ==== 20-dose.js ==== */
/* ============================================================
   PW.dose — the dosage engine
   ------------------------------------------------------------
   Contract, in priority order:
     1. Never return an amount that implies a rate above the product's
        maximum labeled rate, or above any machine-checkable ceiling
        carried on the product record. If a requested rate would exceed
        one, the engine clamps to the ceiling and reports which label
        statement bound it.
     2. Never invent a rate. If the label has no number for a scenario,
        the engine refuses to calculate and says why.
     3. Show the arithmetic: measurement x rate = amount, with the
        measured quantity named and the depth source named.
   ============================================================ */
PW.dose = (function () {
  'use strict';

  var UNIT = {
    gal: { one: 'gallon', many: 'gallons', abbr: 'gal' },
    qt: { one: 'quart', many: 'quarts', abbr: 'qt' },
    pt: { one: 'pint', many: 'pints', abbr: 'pt' },
    fl_oz: { one: 'fluid ounce', many: 'fluid ounces', abbr: 'fl oz' },
    lb: { one: 'pound', many: 'pounds', abbr: 'lb' },
    oz: { one: 'ounce', many: 'ounces', abbr: 'oz' },
    pdu: { one: 'PDU', many: 'PDU', abbr: 'PDU' },
    ppm: { one: 'ppm', many: 'ppm', abbr: 'ppm' },
    ppb: { one: 'ppb', many: 'ppb', abbr: 'ppb' },
    percent: { one: '%', many: '%', abbr: '%' }
  };
  function unitAbbr(u) { return (UNIT[u] && UNIT[u].abbr) || u || ''; }

  var OBJ_LABEL = {
    algae: 'Algae',
    submersed_weeds: 'Submersed weeds',
    floating_weeds: 'Floating weeds',
    emergent_shoreline_weeds: 'Shoreline / emergent weeds',
    nutrient_phosphorus: 'Nutrient / phosphorus management',
    whole_pond_maintenance: 'Whole-pond maintenance'
  };

  var MEASURE_META = {
    zone_acres: { label: 'treatment-zone surface area', unit: 'acres', scope: 'zone', kind: 'area' },
    zone_acreft: { label: 'treatment-zone volume', unit: 'acre-feet', scope: 'zone', kind: 'volume' },
    zone_sqft: { label: 'treatment-zone surface area', unit: 'sq ft', scope: 'zone', kind: 'area' },
    zone_sqft_1000: { label: 'treatment-zone surface area', unit: 'thousand sq ft', scope: 'zone', kind: 'area' },
    zone_gal_10000: { label: 'treatment-zone volume', unit: 'ten-thousand gallons', scope: 'zone', kind: 'volume' },
    pond_acres: { label: 'whole-pond surface area', unit: 'acres', scope: 'pond', kind: 'area' },
    pond_acreft: { label: 'whole-pond volume', unit: 'acre-feet', scope: 'pond', kind: 'volume' },
    pond_sqft: { label: 'whole-pond surface area', unit: 'sq ft', scope: 'pond', kind: 'area' },
    pond_sqft_1000: { label: 'whole-pond surface area', unit: 'thousand sq ft', scope: 'pond', kind: 'area' },
    pond_gal_10000: { label: 'whole-pond volume', unit: 'ten-thousand gallons', scope: 'pond', kind: 'volume' },
    shoreline_ft: { label: 'shoreline length', unit: 'linear feet', scope: 'shoreline', kind: 'length' },
    spray_volume_gal: { label: 'spray solution', unit: 'gallons', scope: 'spray', kind: 'spray' }
  };

  /* ---------------------------------------------------------- measurements */

  /**
   * measures(geo, inputs) -> every quantity a rate might be multiplied by.
   *   geo    : result of PW.geo.measure
   *   inputs : { pondDepthFt, zoneDepthFt, depthMode, growthHeightFt, sprayGal }
   * depthMode: 'pond'  = use the pond average depth for the zone too
   *            'zone'  = use a separately entered treatment-zone depth
   *            'product' = the selected rate dictates the depth
   */
  function measures(geo, inputs) {
    inputs = inputs || {};
    var pondDepth = num(inputs.pondDepthFt);
    var zoneDepth;
    if (inputs.depthMode === 'zone') zoneDepth = num(inputs.zoneDepthFt);
    else zoneDepth = pondDepth;

    var growthHeight = num(inputs.growthHeightFt);

    var m = {
      pondSqft: geo.pondSqft, pondAcres: geo.pondAcres, perimeterFt: geo.perimeterFt,
      zoneSqft: geo.zoneSqft, zoneAcres: geo.zoneAcres, zonePct: geo.zonePct,
      coreSqft: geo.coreSqft,
      pondDepthFt: pondDepth, zoneDepthFt: zoneDepth, growthHeightFt: growthHeight,
      depthMode: inputs.depthMode || 'pond',
      sprayGal: num(inputs.sprayGal)
    };
    m.pondAcreFt = m.pondAcres * pondDepth;
    m.zoneAcreFt = m.zoneAcres * zoneDepth;
    m.pondGal = m.pondAcreFt * PW.geo.GAL_PER_ACREFT;
    m.zoneGal = m.zoneAcreFt * PW.geo.GAL_PER_ACREFT;
    // used only by the two growth-height products
    m.zoneAcreFtGrowth = m.zoneAcres * growthHeight;
    m.pondAcreFtGrowth = m.pondAcres * growthHeight;
    return m;
  }

  function num(v) { var n = parseFloat(v); return isFinite(n) && n > 0 ? n : 0; }

  /**
   * Resolve which measured number a rate multiplies, and which depth fed it.
   */
  function resolveMeasure(rate, m) {
    var key = rate.measure;
    var meta = MEASURE_META[key] || { label: key, unit: '', scope: 'zone', kind: 'other' };
    var useGrowth = rate.depthSource === 'growth_height';
    var v = 0, depthUsed = null, depthLabel = null;

    switch (key) {
      case 'zone_acres': v = m.zoneAcres; break;
      case 'pond_acres': v = m.pondAcres; break;
      case 'zone_sqft': v = m.zoneSqft; break;
      case 'pond_sqft': v = m.pondSqft; break;
      case 'zone_sqft_1000': v = m.zoneSqft / 1000; break;
      case 'pond_sqft_1000': v = m.pondSqft / 1000; break;
      case 'shoreline_ft': v = m.perimeterFt; break;
      case 'spray_volume_gal': v = m.sprayGal; break;
      case 'zone_acreft':
        v = useGrowth ? m.zoneAcreFtGrowth : m.zoneAcreFt;
        depthUsed = useGrowth ? m.growthHeightFt : m.zoneDepthFt;
        depthLabel = useGrowth ? 'average height of plant growth in the water column'
          : (m.depthMode === 'zone' ? 'treatment-zone average depth (entered separately)'
            : 'pond average depth');
        break;
      case 'pond_acreft':
        v = useGrowth ? m.pondAcreFtGrowth : m.pondAcreFt;
        depthUsed = useGrowth ? m.growthHeightFt : m.pondDepthFt;
        depthLabel = useGrowth ? 'average height of plant growth in the water column' : 'pond average depth';
        break;
      case 'zone_gal_10000':
        v = m.zoneGal / 10000; depthUsed = m.zoneDepthFt;
        depthLabel = m.depthMode === 'zone' ? 'treatment-zone average depth (entered separately)' : 'pond average depth';
        break;
      case 'pond_gal_10000':
        v = m.pondGal / 10000; depthUsed = m.pondDepthFt; depthLabel = 'pond average depth';
        break;
      default: v = 0;
    }
    return {
      key: key, value: v, meta: meta,
      depthUsed: depthUsed, depthLabel: depthLabel,
      scopeLabel: meta.scope === 'pond' ? 'whole mapped pond'
        : meta.scope === 'zone' ? 'mapped treatment zone'
          : meta.scope === 'shoreline' ? 'mapped shoreline' : 'spray solution'
    };
  }

  /* ---------------------------------------------------------- ceilings */

  // Which per-unit basis a cap applies to, expressed in the same terms the
  // engine already computes, so a cap can be compared to an actual rate.
  function capApplies(cap, rate, resolved, m) {
    if (cap.unit !== effUnit(rate)) return false;
    var depth = resolved.depthUsed != null ? resolved.depthUsed : m.zoneDepthFt;
    if (cap.whenDepthLte != null && !(depth > 0 && depth <= cap.whenDepthLte)) return false;
    if (cap.whenDepthGt != null && !(depth > cap.whenDepthGt)) return false;
    var basisMatch = {
      per_acre_foot: ['zone_acreft', 'pond_acreft'],
      per_surface_acre: ['zone_acres', 'pond_acres'],
      per_1000_sqft: ['zone_sqft_1000', 'pond_sqft_1000'],
      per_10000_gallons: ['zone_gal_10000', 'pond_gal_10000']
    }[cap.basis];
    return !!basisMatch && basisMatch.indexOf(rate.measure) >= 0;
  }

  function effUnit(rate) {
    return (rate.concentration && rate.concentration.productUnit) || rate.unit;
  }

  /* ---------------------------------------------------------- main calc */

  /**
   * calc(product, rate, m, opts) -> a fully explained dosage, or a refusal.
   *   opts : { concentration, ratePick ('low'|'typical'|'high'|number),
   *            containerSize, containerUnit }
   */
  function calc(product, rate, m, opts) {
    opts = opts || {};
    var res = {
      productId: product.id, productName: product.name,
      rateId: rate.id, rateLabel: rate.label,
      objective: rate.objective, objectiveLabel: OBJ_LABEL[rate.objective] || rate.objective,
      ok: false, blocked: null, warnings: [], clamps: [],
      unit: effUnit(rate), unitAbbr: unitAbbr(effUnit(rate)),
      basis: rate.basis, steps: []
    };

    if (rate.calculable === false) {
      res.blocked = rate.blockedReason || 'The label does not provide enough information to calculate a dosage for this scenario.';
      return res;
    }

    if (rate.mandatoryNote) res.mandatoryNote = rate.mandatoryNote;
    if (rate.aliasOf) res.aliasOf = rate.aliasOf;

    var r = resolveMeasure(rate, m);
    res.measure = r;

    if (rate.requiresSprayVolume && !(m.sprayGal > 0)) {
      res.blocked = rate.blockedReason ||
        'This is a percent-solution treatment. Enter the volume of spray solution you plan to mix to get a product amount.';
      return res;
    }

    if (!(r.value > 0)) {
      if (r.meta.kind === 'volume' && !(r.depthUsed > 0)) {
        res.blocked = 'This rate is applied per unit of water volume, so it needs a depth. Enter the '
          + (rate.depthSource === 'growth_height' ? 'average height of plant growth in the water column' : 'average depth') + '.';
      } else if (r.meta.scope === 'zone' && m.zoneAcres === 0) {
        res.blocked = 'This rate is applied to the treatment zone, but the treatment zone is currently zero. Enter how far aquatic growth extends from shore.';
      } else {
        res.blocked = 'Nothing to multiply the rate by yet — finish mapping the pond and entering depth.';
      }
      return res;
    }

    /* ---- the per-unit rate, low and high ---- */
    var lo, hi, typ = null, rateUnitText, concUsed = null;

    if (rate.concentration) {
      var c = rate.concentration;
      var ceil = c.labelMaxConc != null ? Math.min(rate.max != null ? rate.max : Infinity, c.labelMaxConc)
        : (rate.max != null ? rate.max : null);
      var floor = rate.min != null ? rate.min : null;
      var want = opts.concentration != null ? parseFloat(opts.concentration)
        : (rate.typical != null ? rate.typical : (ceil != null ? ceil : floor));
      concUsed = want;
      if (ceil != null && want > ceil) {
        concUsed = ceil;
        res.clamps.push({
          what: 'target concentration',
          from: want + ' ' + c.concUnit, to: ceil + ' ' + c.concUnit,
          reason: 'Clamped to the maximum labeled concentration for this product.'
        });
      }
      if (floor != null && concUsed < floor) {
        res.warnings.push({
          kind: 'below_label_min',
          text: 'The selected ' + c.concLabel + ' (' + fmt(concUsed) + ') is below the lowest rate this label states for '
            + (OBJ_LABEL[rate.objective] || rate.objective).toLowerCase() + ' (' + fmt(floor) + '). A dose below the labeled rate range may not control the target growth.'
        });
      }
      res.concentration = { value: concUsed, unit: c.concUnit, label: c.concLabel, min: floor, max: ceil, formula: c.formula };
      lo = hi = concUsed * c.factor;
      rateUnitText = unitAbbr(c.productUnit) + ' per ' + perUnitText(rate.measure);
      res.steps.push({
        text: fmt(concUsed) + ' ' + c.concUnit + ' × ' + c.factor + ' ' + unitAbbr(c.productUnit) + ' per acre-foot per ' + c.concUnit
          + ' = ' + fmt(lo) + ' ' + unitAbbr(c.productUnit) + ' per acre-foot',
        note: 'Label conversion: ' + c.formula
      });
    } else {
      lo = rate.min != null ? rate.min : rate.typical;
      hi = rate.max != null ? rate.max : rate.typical;
      typ = rate.typical;
      if (lo == null) lo = hi;
      if (hi == null) hi = lo;
      rateUnitText = unitAbbr(rate.unit) + ' per ' + perUnitText(rate.measure);
    }

    /* ---- pick the rate actually used ---- */
    var pick = opts.ratePick;
    var used;
    if (typeof pick === 'number') used = pick;
    else if (pick === 'low') used = lo;
    else if (pick === 'high') used = hi;
    else if (pick === 'typical' && typ != null) used = typ;
    else used = (typ != null ? typ : hi);

    if (used > hi) {
      res.clamps.push({
        what: 'application rate',
        from: fmt(used) + ' ' + rateUnitText, to: fmt(hi) + ' ' + rateUnitText,
        reason: 'Clamped to the maximum labeled rate for this use.'
      });
      used = hi;
    }
    if (lo != null && used < lo) {
      res.warnings.push({
        kind: 'below_label_min',
        text: 'The selected rate (' + fmt(used) + ' ' + rateUnitText + ') is below the label minimum of '
          + fmt(lo) + '. A dose below the labeled rate range may not control the target growth.'
      });
    }

    /* ---- enforce every machine-checkable ceiling on the product ---- */
    var appliedCaps = [];
    (product.caps || []).forEach(function (cap) {
      if (!capApplies(cap, rate, r, m)) return;
      appliedCaps.push(cap);
      if (cap.scope === 'application' && used > cap.max) {
        res.clamps.push({
          what: 'application rate',
          from: fmt(used) + ' ' + rateUnitText,
          to: fmt(cap.max) + ' ' + rateUnitText,
          reason: cap.text
        });
        used = cap.max;
        hi = Math.min(hi, cap.max);
        lo = Math.min(lo, cap.max);
      }
      if (cap.scope === 'season') {
        var seasonTotal = cap.max * r.value;
        res.season = res.season || [];
        res.season.push({
          text: cap.text,
          budget: seasonTotal, unit: unitAbbr(cap.unit),
          perUnit: cap.max, basis: cap.basis,
          usedByThis: used * r.value,
          pctOfBudget: seasonTotal > 0 ? (used * r.value) / seasonTotal * 100 : 0
        });
      }
    });
    res.appliedCaps = appliedCaps;

    /* ---- amounts ---- */
    res.rateUsed = used;
    res.rateLow = lo; res.rateHigh = hi; res.rateTypical = typ;
    res.rateUnitText = rateUnitText;
    res.amount = used * r.value;
    res.amountLow = lo * r.value;
    res.amountHigh = hi * r.value;
    res.hasRange = Math.abs(hi - lo) > 1e-9;
    res.ok = true;

    res.formula = fmt(r.value) + ' ' + r.meta.unit + ' (' + r.meta.label + ')'
      + '  ×  ' + fmt(used) + ' ' + rateUnitText
      + '  =  ' + fmt(res.amount) + ' ' + res.unitAbbr;

    /* ---- depth-validity warnings ---- */
    if (rate.depthValidity) {
      var dv = rate.depthValidity;
      var d = m.pondDepthFt;
      if (d > 0 && Math.abs(d - dv.equals) > (dv.tolerance || 0.25)) {
        res.warnings.push({
          kind: 'depth_mismatch',
          text: 'This rate is only stated by the label at a ' + dv.equals + ' ft average depth, but the pond you mapped averages '
            + fmt(d) + ' ft. ' + dv.text + ' Treat this figure as out of scope for your pond and consult the label or a SePRO Aquatic Specialist.'
        });
      }
    }

    /* ---- practical / measurability warnings ---- */
    if (res.amount > 0 && res.amount < 0.05) {
      res.warnings.push({
        kind: 'below_measurable',
        text: 'The calculated amount (' + fmt(res.amount) + ' ' + res.unitAbbr
          + ') is smaller than can be measured or applied accurately at this scale. Consider treating a larger area at one time, or ask a SePRO Aquatic Specialist how to handle a dose this small.'
      });
    }

    /* ---- packaging ---- */
    res.packaging = packaging(product, res, opts);

    return res;
  }

  function perUnitText(measureKey) {
    return {
      zone_acres: 'surface acre', pond_acres: 'surface acre',
      zone_acreft: 'acre-foot', pond_acreft: 'acre-foot',
      zone_sqft: 'sq ft', pond_sqft: 'sq ft',
      zone_sqft_1000: '1,000 sq ft', pond_sqft_1000: '1,000 sq ft',
      zone_gal_10000: '10,000 gallons', pond_gal_10000: '10,000 gallons',
      shoreline_ft: 'linear foot of shoreline',
      spray_volume_gal: 'gallon of spray solution'
    }[measureKey] || 'unit';
  }

  /* ---------------------------------------------------------- packaging */

  /**
   * packSource is an optional hook the host can install to supply a container
   * size the label does not state. On Shopify it reads the pack size the
   * merchant configured against the linked product, which closes the gap left
   * by the 23 of 28 labels that state no net contents.
   *   packSource(productId, unit) -> {size, unit, label, ...} | null
   */
  var packSource = null;
  function setPackSource(fn) { packSource = fn; }

  function packaging(product, res, opts) {
    var out = { available: false, source: null, containers: [] };
    var labelPkgs = (product.packages || []).filter(function (p) {
      return p.size && p.unit === res.unit;
    });
    var hostPack = null;
    if (packSource) {
      try { hostPack = packSource(product.id, res.unit); } catch (e) { hostPack = null; }
    }
    var size = null, srcLabel = null;
    if (opts.containerSize && parseFloat(opts.containerSize) > 0 &&
      (!opts.containerUnit || opts.containerUnit === res.unit)) {
      size = parseFloat(opts.containerSize);
      srcLabel = 'container size you entered';
    } else if (hostPack && hostPack.size > 0) {
      size = hostPack.size;
      srcLabel = hostPack.label || 'pack size configured for this product in the store';
      out.pack = hostPack;
    } else if (labelPkgs.length) {
      size = labelPkgs[0].size;
      srcLabel = 'net contents stated on the label (' + labelPkgs[0].label + ')';
    }
    if (!size) {
      out.reason = (product.packages || []).length
        ? 'The label states a container size in a different unit than this rate. Enter your container size to see how many containers to buy.'
        : 'This label does not state a container or package size, so container counts cannot be derived from label data. Enter the size of the container you are buying and the count will be calculated.';
      return out;
    }
    var count = Math.ceil(res.amount / size - 1e-9);
    if (count < 1) count = 1;
    out.available = true;
    out.source = srcLabel;
    out.containerSize = size;
    out.unit = res.unitAbbr;
    out.count = count;
    out.purchaseAmount = count * size;
    out.leftover = Math.max(0, count * size - res.amount);
    out.exact = res.amount;
    return out;
  }

  /* ---------------------------------------------------------- filtering */

  function productsFor(objective, products) {
    return products.filter(function (p) {
      return (p.objectives || []).indexOf(objective) >= 0;
    });
  }

  function ratesFor(product, objective) {
    return (product.rates || []).filter(function (r) { return r.objective === objective; });
  }

  /* ---------------------------------------------------------- formatting */

  function fmt(n) {
    if (n == null || !isFinite(n)) return '—';
    var a = Math.abs(n);
    if (a === 0) return '0';
    if (a < 0.01) return n.toPrecision(2);
    if (a < 1) return n.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
    if (a < 10) return n.toFixed(2);
    if (a < 1000) return n.toFixed(1);
    return Math.round(n).toLocaleString();
  }

  return {
    measures: measures, calc: calc, setPackSource: setPackSource,
    productsFor: productsFor, ratesFor: ratesFor,
    resolveMeasure: resolveMeasure,
    fmt: fmt, unitAbbr: unitAbbr, perUnitText: perUnitText,
    OBJ_LABEL: OBJ_LABEL, MEASURE_META: MEASURE_META
  };
})();


/* ==== 30-store.js ==== */
/* ============================================================
   PW.store — persistence, accounts and role-scoped access
   ------------------------------------------------------------
   Proof of concept only. Everything lives in browser storage on this
   device, and the role switcher is an unauthenticated demo control.
   The read/write surface below (list*, get*, save*, visible*) is the
   seam a real customer-account API or CRM would replace: the views
   never touch storage directly.
   ============================================================ */
PW.store = (function () {
  'use strict';

  var KEY = 'pondwise.poc.v2';
  var mem = null;          // in-memory fallback if storage is unavailable
  var storageOK = true;

  function read() {
    if (mem) return mem;
    try {
      var raw = window.localStorage.getItem(KEY);
      mem = raw ? JSON.parse(raw) : seed();
    } catch (e) {
      storageOK = false;
      mem = seed();
    }
    return mem;
  }

  function write() {
    if (!mem) return;
    try { window.localStorage.setItem(KEY, JSON.stringify(mem)); }
    catch (e) { storageOK = false; }
  }

  function isPersistent() { return storageOK; }

  /* ------------------------------------------------------------ demo data */

  function seed() {
    var specialists = [
      { id: 'ts-1', name: 'Dana Whitfield', role: 'specialist', region: 'Midwest', accounts: ['acct-1', 'acct-2'] },
      { id: 'ts-2', name: 'Marcus Reyes', role: 'specialist', region: 'Southeast', accounts: ['acct-3'] }
    ];
    var accounts = [
      { id: 'acct-1', name: 'Willow Bend Golf Club', region: 'Midwest', specialistId: 'ts-1', contact: 'grounds@willowbend.example' },
      { id: 'acct-2', name: 'Harding Farms', region: 'Midwest', specialistId: 'ts-1', contact: 'r.harding@example.com' },
      { id: 'acct-3', name: 'Cypress Lakes HOA', region: 'Southeast', specialistId: 'ts-2', contact: 'board@cypresslakes.example' }
    ];
    var users = [
      { id: 'cu-1', name: 'Ray Harding', role: 'customer', accountId: 'acct-2' },
      { id: 'ts-1', name: 'Dana Whitfield', role: 'specialist', region: 'Midwest' },
      { id: 'ts-2', name: 'Marcus Reyes', role: 'specialist', region: 'Southeast' },
      { id: 'sm-1', name: 'Priya Raman', role: 'sales', region: 'All' }
    ];
    // Two small demo ponds so the dashboard and saved-pond views are not empty.
    var ponds = [
      {
        id: 'pond-demo-1', accountId: 'acct-2', name: 'North Irrigation Pond',
        property: 'Harding Farms — north quarter', address: 'Frankfort, IN',
        coords: [
          { lat: 40.28092, lng: -86.51260 }, { lat: 40.28131, lng: -86.51142 },
          { lat: 40.28085, lng: -86.51041 }, { lat: 40.27992, lng: -86.51058 },
          { lat: 40.27960, lng: -86.51178 }, { lat: 40.28010, lng: -86.51268 }
        ],
        depthFt: 5.5, notes: 'Filamentous algae along the west bank most of July. Used for irrigation.',
        photos: [], createdAt: '2026-06-11'
      },
      {
        id: 'pond-demo-2', accountId: 'acct-1', name: 'Hole 7 Pond',
        property: 'Willow Bend Golf Club', address: 'Carmel, IN',
        coords: [
          { lat: 39.97812, lng: -86.11890 }, { lat: 39.97856, lng: -86.11812 },
          { lat: 39.97821, lng: -86.11726 }, { lat: 39.97748, lng: -86.11744 },
          { lat: 39.97731, lng: -86.11842 }
        ],
        depthFt: 4.0, notes: 'Coontail out to roughly 15 ft from the bank on the cart-path side.',
        photos: [], createdAt: '2026-07-02'
      }
    ];
    var calcs = [
      {
        id: 'calc-demo-1', pondId: 'pond-demo-1', accountId: 'acct-2', date: '2026-06-11',
        objective: 'algae', productId: 'captain', productName: 'Captain®',
        rateId: 'filamentous_algae', rateLabel: 'Filamentous (mat-forming) algae — Table 1',
        pondAcres: 1.02, zoneAcres: 0.41, zoneAcreFt: 2.26, depthFt: 5.5, growthFt: 18,
        amount: 4.5, unit: 'gal', notes: 'Treated the west third first.'
      },
      {
        id: 'calc-demo-2', pondId: 'pond-demo-2', accountId: 'acct-1', date: '2026-07-02',
        objective: 'submersed_weeds', productId: 'nautique', productName: 'Nautique® Aquatic Herbicide',
        rateId: 'medium_density_veg_algae', rateLabel: 'Medium relative plant density (Table 1) — 0.6-0.8 ppm copper',
        pondAcres: 0.74, zoneAcres: 0.35, zoneAcreFt: 1.40, depthFt: 4.0, growthFt: 15,
        amount: 3.4, unit: 'gal', notes: ''
      }
    ];
    return {
      version: 2, specialists: specialists, accounts: accounts, users: users,
      ponds: ponds, calcs: calcs, currentUserId: 'ts-1'
    };
  }

  /* ------------------------------------------------------------ roles */

  var ROLE_LABEL = {
    customer: 'Customer',
    specialist: 'Technical Specialist',
    sales: 'Sales & Marketing management'
  };

  var demoRoles = true;
  function hideDemoRoles() { demoRoles = false; }
  function demoRolesVisible() { return demoRoles; }

  /**
   * On Shopify the storefront customer is the identity, and their role comes
   * from customer tags. The customer is added to the user list (replacing any
   * earlier record for the same id), made current, and given an account so
   * their own ponds are scoped to them.
   */
  function registerShopifyCustomer(c) {
    var d = read();
    var acctId = 'acct-' + c.id;
    if (!d.accounts.filter(function (a) { return a.id === acctId; }).length) {
      d.accounts.push({
        id: acctId, name: c.accountName || c.name, region: 'Unassigned',
        specialistId: null, contact: c.email || ''
      });
    }
    var u = {
      id: c.id, name: c.name, role: c.role,
      accountId: c.role === 'customer' ? acctId : null,
      email: c.email, shopify: true
    };
    d.users = d.users.filter(function (x) { return x.id !== c.id; });
    d.users.unshift(u);
    if (c.role === 'specialist') {
      if (!d.specialists.filter(function (s2) { return s2.id === c.id; }).length) {
        d.specialists.push({ id: c.id, name: c.name, role: 'specialist', region: 'Unassigned', accounts: [] });
      }
      // a specialist with no assignments yet still sees their own account
      d.accounts.forEach(function (a) { if (a.id === acctId) a.specialistId = c.id; });
    }
    d.currentUserId = c.id;
    write();
    return u;
  }

  function currentUser() {
    var d = read();
    return d.users.filter(function (u) { return u.id === d.currentUserId; })[0] || d.users[0];
  }

  function setCurrentUser(id) { read().currentUserId = id; write(); }

  function users() { return read().users.slice(); }
  function accounts() { return read().accounts.slice(); }
  function specialists() { return read().specialists.slice(); }

  /**
   * Which accounts the signed-in user may see.
   *   customer   -> only their own account
   *   specialist -> the accounts assigned to them
   *   sales      -> every account
   */
  function visibleAccountIds(user) {
    user = user || currentUser();
    var d = read();
    if (user.role === 'sales') return d.accounts.map(function (a) { return a.id; });
    if (user.role === 'specialist') {
      return d.accounts.filter(function (a) { return a.specialistId === user.id; })
        .map(function (a) { return a.id; });
    }
    return user.accountId ? [user.accountId] : [];
  }

  function visiblePonds(user) {
    var ids = visibleAccountIds(user);
    return read().ponds.filter(function (p) { return ids.indexOf(p.accountId) >= 0; });
  }

  function visibleCalcs(user) {
    var ids = visibleAccountIds(user);
    return read().calcs.filter(function (c) { return ids.indexOf(c.accountId) >= 0; });
  }

  function canSeeDashboard(user) {
    user = user || currentUser();
    return user.role === 'sales' || user.role === 'specialist';
  }

  function accountName(id) {
    var a = read().accounts.filter(function (x) { return x.id === id; })[0];
    return a ? a.name : '—';
  }
  function accountOf(id) {
    return read().accounts.filter(function (x) { return x.id === id; })[0] || null;
  }
  function specialistName(id) {
    var s = read().specialists.filter(function (x) { return x.id === id; })[0];
    return s ? s.name : '—';
  }

  /* ------------------------------------------------------------ ponds */

  function pond(id) { return read().ponds.filter(function (p) { return p.id === id; })[0] || null; }

  function savePond(p) {
    var d = read();
    if (!p.id) { p.id = PW.util.uid('pond'); p.createdAt = PW.util.today(); }
    var i = d.ponds.findIndex(function (x) { return x.id === p.id; });
    if (i >= 0) d.ponds[i] = Object.assign({}, d.ponds[i], p);
    else d.ponds.push(p);
    write();
    return p.id;
  }

  function deletePond(id) {
    var d = read();
    d.ponds = d.ponds.filter(function (p) { return p.id !== id; });
    d.calcs = d.calcs.filter(function (c) { return c.pondId !== id; });
    write();
  }

  /* ------------------------------------------------------------ calcs */

  function saveCalc(c) {
    var d = read();
    if (!c.id) c.id = PW.util.uid('calc');
    if (!c.date) c.date = PW.util.today();
    var i = d.calcs.findIndex(function (x) { return x.id === c.id; });
    if (i >= 0) d.calcs[i] = Object.assign({}, d.calcs[i], c);
    else d.calcs.push(c);
    write();
    return c.id;
  }

  function calcsForPond(pondId) {
    return read().calcs
      .filter(function (c) { return c.pondId === pondId; })
      .sort(function (a, b) { return (b.date || '').localeCompare(a.date || ''); });
  }

  function deleteCalc(id) {
    var d = read();
    d.calcs = d.calcs.filter(function (c) { return c.id !== id; });
    write();
  }

  function resetAll() {
    mem = seed();
    write();
  }

  return {
    ROLE_LABEL: ROLE_LABEL,
    isPersistent: isPersistent,
    registerShopifyCustomer: registerShopifyCustomer,
    hideDemoRoles: hideDemoRoles, demoRolesVisible: demoRolesVisible,
    currentUser: currentUser, setCurrentUser: setCurrentUser,
    users: users, accounts: accounts, specialists: specialists,
    visibleAccountIds: visibleAccountIds, visiblePonds: visiblePonds,
    visibleCalcs: visibleCalcs, canSeeDashboard: canSeeDashboard,
    accountName: accountName, accountOf: accountOf, specialistName: specialistName,
    pond: pond, savePond: savePond, deletePond: deletePond,
    saveCalc: saveCalc, calcsForPond: calcsForPond, deleteCalc: deleteCalc,
    resetAll: resetAll
  };
})();


/* ==== 40-map.js ==== */
/* ============================================================
   PW.map — satellite map, editable pond polygon, treatment-zone overlay
   ------------------------------------------------------------
   The pond boundary is a single editable, draggable google.maps.Polygon.
   Vertices can be dragged, inserted (drag a midpoint handle) or removed
   (right-click / long-press) at any time without clearing the rest of the
   workflow. "Add points" mode appends vertices on map click.

   The treatment zone is drawn as the pond polygon with the inner contour
   punched out as a hole, so what the user sees is exactly the band the
   calculator measured.
   ============================================================ */
PW.map = (function () {
  'use strict';

  var map, poly, zonePoly, searchMarker, meMarker, ac;
  var mode = 'add';                 // 'add' | 'edit'
  var onChange = function () { };
  var lastPath = [];
  var pathMVC = null;               // the one MVCArray we own; see init()
  var quiet = false;                // suppress change events during a bulk rewrite

  var STROKE = '#246b3f', FILL = '#2a7fb8', ZONE = '#e8730a';

  function init(mapEl, opts) {
    opts = opts || {};
    onChange = opts.onChange || onChange;

    var defaults = PW.mapDefaults || {};
    map = new google.maps.Map(mapEl, {
      center: opts.center || defaults.center || { lat: 39.8283, lng: -98.5795 },
      zoom: opts.zoom || defaults.zoom || 5,
      mapTypeId: 'satellite',
      tilt: 0,
      mapTypeControl: true,
      mapTypeControlOptions: { mapTypeIds: ['satellite', 'hybrid', 'roadmap', 'terrain'] },
      streetViewControl: false,
      fullscreenControl: true,
      rotateControl: false,
      gestureHandling: 'greedy',
      clickableIcons: false
    });

    // We create and hold the vertex MVCArray ourselves rather than letting the
    // Polygon make one. Two reasons: a Polygon constructed with an empty paths
    // array has no path at all, so getPath() returns undefined and binding a
    // listener to it throws; and setPath() would swap the array out from under
    // our listeners, so they would have to be re-bound on every load (and would
    // leak). Owning one array means the listeners are bound exactly once.
    pathMVC = new google.maps.MVCArray();

    poly = new google.maps.Polygon({
      map: map, paths: pathMVC,
      strokeColor: STROKE, strokeOpacity: 1, strokeWeight: 2.5,
      fillColor: FILL, fillOpacity: 0.22,
      editable: false, draggable: false, zIndex: 2
    });

    zonePoly = new google.maps.Polygon({
      map: map, paths: [],
      strokeColor: ZONE, strokeOpacity: 0.95, strokeWeight: 2,
      fillColor: ZONE, fillOpacity: 0.42,
      clickable: false, zIndex: 1
    });

    map.addListener('click', function (ev) {
      if (mode !== 'add') return;
      appendVertex(ev.latLng);
    });

    // Right-click a vertex to delete it.
    poly.addListener('rightclick', function (ev) {
      if (ev.vertex == null) return;
      if (pathMVC.getLength() <= 3) { onChange(read(), 'min_vertices'); return; }
      pathMVC.removeAt(ev.vertex);
    });

    ['insert_at', 'remove_at', 'set_at'].forEach(function (ev) {
      google.maps.event.addListener(pathMVC, ev, emit);
    });
    google.maps.event.addListener(poly, 'dragend', emit);

    return map;
  }

  function emit() {
    if (quiet) return;
    lastPath = read();
    onChange(lastPath);
  }

  function appendVertex(latLng) { pathMVC.push(latLng); }

  function read() {
    var out = [];
    if (!pathMVC) return out;
    pathMVC.forEach(function (ll) { out.push({ lat: ll.lat(), lng: ll.lng() }); });
    return out;
  }

  function setPath(coords, fit) {
    // Rewrite the vertices in place. clear() and push() each fire a change
    // event, so they are muted and a single event is emitted at the end.
    quiet = true;
    try {
      pathMVC.clear();
      (coords || []).forEach(function (c) {
        pathMVC.push(new google.maps.LatLng(c.lat, c.lng));
      });
    } finally {
      quiet = false;
    }
    if (fit && coords && coords.length) fitTo(coords);
    emit();
  }

  function fitTo(coords) {
    if (!coords || !coords.length) return;
    var b = new google.maps.LatLngBounds();
    coords.forEach(function (c) { b.extend(new google.maps.LatLng(c.lat, c.lng)); });
    map.fitBounds(b, 60);
  }

  function setMode(m) {
    mode = m;
    var editing = (m === 'edit');
    poly.setEditable(editing);
    poly.setDraggable(editing);
    map.setOptions({ draggableCursor: m === 'add' ? 'crosshair' : null });
    return mode;
  }
  function getMode() { return mode; }

  function clearPolygon() {
    quiet = true;
    try { pathMVC.clear(); } finally { quiet = false; }
    zonePoly.setPaths([]);
    emit();
  }

  /* ---------- treatment-zone overlay ---------- */

  function drawZone(geo) {
    if (!geo || !geo.valid || geo.zoneSqft <= 0) { zonePoly.setPaths([]); return; }
    var outer = read().map(function (c) { return new google.maps.LatLng(c.lat, c.lng); });
    if (!outer.length) { zonePoly.setPaths([]); return; }

    if (geo.wholePond || !geo.rings || !geo.rings.length) {
      // the zone is the entire pond — no untreated core to punch out
      zonePoly.setPaths([outer]);
      return;
    }
    var paths = [outer];
    geo.rings.forEach(function (ring) {
      // holes must wind opposite to the outer ring; reversing is enough for
      // the renderer's even-odd fill rule
      var h = ring.map(function (c) { return new google.maps.LatLng(c.lat, c.lng); });
      paths.push(h.slice().reverse());
    });
    zonePoly.setPaths(paths);
  }

  /* ---------- location ---------- */

  /**
   * Address suggestions are a convenience, not a dependency. If the Places
   * library is absent or the key does not permit it, this returns null and the
   * typed search (Geocoding) and the coordinate entry both still work.
   */
  function attachAutocomplete(input, cb) {
    if (!google.maps.places || !google.maps.places.Autocomplete) return null;
    try {
      ac = new google.maps.places.Autocomplete(input, {
        fields: ['formatted_address', 'geometry', 'name'],
        types: ['geocode']
      });
      ac.bindTo('bounds', map);
      ac.addListener('place_changed', function () {
        var pl = ac.getPlace();
        if (!pl || !pl.geometry) return;
        var addr = pl.formatted_address || pl.name || input.value;
        if (pl.geometry.viewport) map.fitBounds(pl.geometry.viewport);
        else { map.setCenter(pl.geometry.location); map.setZoom(19); }
        mark(pl.geometry.location, addr);
        cb && cb({ ok: true, address: addr, location: latlngObj(pl.geometry.location) });
      });
      return ac;
    } catch (e) {
      return null;
    }
  }

  function placesAvailable() { return !!ac; }

  function geocode(q, cb) {
    // Accept raw coordinates as well as an address.
    var m = String(q).trim().match(/^(-?\d{1,3}(?:\.\d+)?)\s*[, ]\s*(-?\d{1,3}(?:\.\d+)?)$/);
    if (m) {
      var lat = parseFloat(m[1]), lng = parseFloat(m[2]);
      if (Math.abs(lat) <= 90 && Math.abs(lng) <= 180) {
        var ll = new google.maps.LatLng(lat, lng);
        map.setCenter(ll); map.setZoom(19);
        mark(ll, lat.toFixed(5) + ', ' + lng.toFixed(5));
        cb({ ok: true, address: lat.toFixed(5) + ', ' + lng.toFixed(5), location: { lat: lat, lng: lng } });
        return;
      }
    }
    new google.maps.Geocoder().geocode({ address: q }, function (res, status) {
      if (status === 'OK' && res && res[0]) {
        var r = res[0];
        if (r.geometry.viewport) map.fitBounds(r.geometry.viewport);
        else { map.setCenter(r.geometry.location); map.setZoom(19); }
        map.setZoom(Math.max(map.getZoom(), 18));
        mark(r.geometry.location, r.formatted_address);
        cb({ ok: true, address: r.formatted_address, location: latlngObj(r.geometry.location) });
      } else {
        cb({ ok: false, error: status });
      }
    });
  }

  function locate(cb) {
    if (!navigator.geolocation) { cb({ ok: false, error: 'unsupported' }); return; }
    navigator.geolocation.getCurrentPosition(function (pos) {
      var ll = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
      map.setCenter(ll); map.setZoom(19);
      if (meMarker) meMarker.setMap(null);
      meMarker = new google.maps.Marker({
        position: ll, map: map, title: 'Your location',
        icon: {
          path: google.maps.SymbolPath.CIRCLE, scale: 7,
          fillColor: '#1a73e8', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 2
        }
      });
      cb({
        ok: true, location: { lat: pos.coords.latitude, lng: pos.coords.longitude },
        accuracy: pos.coords.accuracy
      });
    }, function (err) {
      cb({ ok: false, error: err && err.code === 1 ? 'denied' : 'unavailable' });
    }, { enableHighAccuracy: true, timeout: 12000, maximumAge: 0 });
  }

  function mark(loc, title) {
    if (searchMarker) searchMarker.setMap(null);
    searchMarker = new google.maps.Marker({ position: loc, map: map, title: title || '', opacity: 0.85 });
  }

  function latlngObj(ll) { return { lat: ll.lat(), lng: ll.lng() }; }

  function center() { var c = map.getCenter(); return c ? latlngObj(c) : null; }
  function zoom() { return map.getZoom(); }

  /* ---------- static image for the printed report ---------- */

  function staticUrl(coords, geo, apiKey, size) {
    if (!coords || coords.length < 3) return null;
    var enc = google.maps.geometry.encoding.encodePath(
      coords.map(function (c) { return new google.maps.LatLng(c.lat, c.lng); })
    );
    var parts = [
      'https://maps.googleapis.com/maps/api/staticmap?size=' + (size || '640x400'),
      'scale=2', 'maptype=satellite',
      'path=' + encodeURIComponent('color:0x246b3fff|weight:3|fillcolor:0x2a7fb855|enc:' + enc)
    ];
    if (geo && geo.rings) {
      geo.rings.slice(0, 3).forEach(function (ring) {
        if (ring.length < 3) return;
        var e2 = google.maps.geometry.encoding.encodePath(
          ring.map(function (c) { return new google.maps.LatLng(c.lat, c.lng); })
        );
        parts.push('path=' + encodeURIComponent('color:0xe8730aff|weight:2|enc:' + e2));
      });
    }
    parts.push('key=' + encodeURIComponent(apiKey));
    return parts.join('&');
  }

  return {
    init: init, setPath: setPath, read: read, fitTo: fitTo,
    setMode: setMode, getMode: getMode, clearPolygon: clearPolygon,
    drawZone: drawZone, attachAutocomplete: attachAutocomplete,
    geocode: geocode, locate: locate, center: center, zoom: zoom,
    placesAvailable: placesAvailable,
    staticUrl: staticUrl,
    teardown: function () {
      map = poly = zonePoly = searchMarker = meMarker = ac = null;
      pathMVC = null; lastPath = []; mode = 'add'; quiet = false;
      onChange = function () { };
    },
    get instance() { return map; },
    // exposed for the test harness, which asserts the vertex listeners are
    // bound exactly once across repeated pond loads
    __pathArray: function () { return pathMVC; }
  };
})();


/* ==== 50-planner.js ==== */
/* ============================================================
   PW.planner — the guided workflow
   ------------------------------------------------------------
   All ten steps are rendered at once in a single scrolling column, so the
   user can move backward and change any input without losing anything
   downstream. The stepper on the left scrolls to a step and shows which
   ones are satisfied; it never hides or resets a later step.
   ============================================================ */
PW.planner = (function () {
  'use strict';

  var U = PW.util, D = PW.dose, el = U.el;
  var PRODUCTS = [];
  var S = null;          // working state
  var geo = null, M = null, RESULT = null;
  var host = {};         // cached DOM nodes

  var STEPS = [
    { n: 1, key: 'find', label: 'Find the pond' },
    { n: 2, key: 'map', label: 'Map the shoreline' },
    { n: 3, key: 'confirm', label: 'Confirm the mapped area' },
    { n: 4, key: 'depth', label: 'Enter average depth' },
    { n: 5, key: 'growth', label: 'Growth distance from shore' },
    { n: 6, key: 'category', label: 'Select growth category' },
    { n: 7, key: 'product', label: 'Select product and rate' },
    { n: 8, key: 'zone', label: 'Review the treatment zone' },
    { n: 9, key: 'dose', label: 'View the dosage calculation' },
    { n: 10, key: 'summary', label: 'Generate the summary' }
  ];

  var OBJECTIVES = [
    { id: 'algae', label: 'Algae', desc: 'Planktonic, filamentous or mat-forming algae, and macroalgae such as Chara and Nitella.' },
    { id: 'submersed_weeds', label: 'Submersed weeds', desc: 'Plants growing under the surface — coontail, pondweeds, naiads, milfoil, hydrilla, elodea.' },
    { id: 'floating_weeds', label: 'Floating weeds', desc: 'Plants floating on the surface — duckweed, watermeal, salvinia, water hyacinth, water lettuce.' },
    { id: 'emergent_shoreline_weeds', label: 'Shoreline / emergent weeds', desc: 'Plants rooted in shallow water standing above the surface — cattails, phragmites, water lilies, spatterdock.' },
    { id: 'nutrient_phosphorus', label: 'Nutrient / phosphorus management', desc: 'Products whose label makes a nutrient or phosphorus claim alongside algae control.' },
    { id: 'whole_pond_maintenance', label: 'Whole-pond maintenance', desc: 'Whole-waterbody programs and season-long suppression, including dyes and shading agents.' }
  ];

  /* ---------------------------------------------------------------- state */

  function blank() {
    return {
      step: 1,
      pondId: null, accountId: null,
      pondName: '', property: '', address: '',
      coords: [],
      pondDepthFt: '', zoneDepthFt: '', depthMode: 'pond',
      growthFt: '', growthHeightFt: '',
      objective: '', productId: '', rateId: '',
      concentration: null, ratePick: 'high',
      containerSize: '', sprayGal: '',
      notes: '', photos: [],
      savedCalcId: null
    };
  }

  function state() { return S; }

  function loadPond(p) {
    S = blank();
    S.pondId = p.id; S.accountId = p.accountId;
    S.pondName = p.name || ''; S.property = p.property || ''; S.address = p.address || '';
    S.coords = (p.coords || []).slice();
    S.pondDepthFt = p.depthFt != null ? String(p.depthFt) : '';
    S.notes = p.notes || ''; S.photos = (p.photos || []).slice();
    render();
    if (S.coords.length >= 3) { PW.map.setPath(S.coords, true); }
    recompute();
  }

  /* ---------------------------------------------------------------- boot */

  function mount(rootEl, products) {
    PRODUCTS = products;
    S = blank();
    var u = PW.store.currentUser();
    if (u.role === 'customer') S.accountId = u.accountId;
    else S.accountId = (PW.store.visibleAccountIds(u)[0] || null);

    rootEl.appendChild(buildShell());
    PW.map.init(host.mapEl, { onChange: onPathChange });
    PW.map.setMode('add');
    var acOK = PW.map.attachAutocomplete(host.search, function (r) {
      if (r.ok) { S.address = r.address; setStatus('Location found. Zoom in until the pond fills the map, then click around its edge.'); render(); }
    });
    if (!acOK) {
      note(host.searchNote, 'info',
        '<b>Address suggestions are unavailable</b>The Places API is not enabled on this API key, so the ' +
        'dropdown of suggestions will not appear. Typing an address and pressing <b>Search</b> still works, ' +
        'and so does pasting coordinates as “latitude, longitude”.');
    }
    setMode('add');
    setStatus('Search an address above, or use your location, then click around the pond edge to drop points.');
    render();
    recompute();
  }

  function buildShell() {
    var wrap = el('div', { class: 'pw-planner' });

    /* left: stepper */
    host.stepperBox = el('div', { class: 'pw-card pw-stepper' });
    wrap.appendChild(host.stepperBox);

    /* centre: map + steps */
    var mid = el('div', { class: 'pw-rail-mid' });

    var searchCard = el('div', { class: 'pw-card' });
    searchCard.appendChild(el('h3', {}, [el('span', { class: 'pw-num', text: '1' }), 'Find the pond']));
    searchCard.appendChild(el('p', {
      class: 'pw-sub',
      html: 'Search an address, drop in coordinates as &ldquo;lat, lng&rdquo;, or use the device location if you are ' +
        'standing at the pond. If the suggestions list shows warning icons instead of addresses, the Places API is ' +
        'not permitted on this key &mdash; press <b>Search</b> instead, which uses a different API.'
    }));
    var row = el('div', { class: 'pw-searchrow' });
    host.search = el('input', { type: 'search', placeholder: 'Address, place, or 39.9781, -86.1189', 'aria-label': 'Search address, place or coordinates' });
    host.search.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); doSearch(); } });
    row.appendChild(host.search);
    row.appendChild(el('button', { class: 'pw-btn', onclick: doSearch, type: 'button' }, ['Search']));
    row.appendChild(el('button', { class: 'pw-btn pw-sec', onclick: doLocate, type: 'button' }, ['Use my location']));
    searchCard.appendChild(row);
    host.searchNote = el('div', {});
    searchCard.appendChild(host.searchNote);
    mid.appendChild(searchCard);

    /* map */
    var mw = el('div', { class: 'pw-mapwrap' });
    mw.style.marginTop = '14px';
    host.mapEl = el('div', { class: 'pw-map', 'aria-label': 'Satellite pond mapping tool' });
    mw.appendChild(host.mapEl);

    var tools = el('div', { class: 'pw-maptools' });
    var g1 = el('div', { class: 'pw-grp' });
    host.btnAdd = el('button', { class: 'pw-mbtn', type: 'button', onclick: function () { setMode('add'); } }, ['✛ Add points']);
    host.btnEdit = el('button', { class: 'pw-mbtn', type: 'button', onclick: function () { setMode('edit'); } }, ['✥ Move / reshape']);
    g1.appendChild(host.btnAdd); g1.appendChild(host.btnEdit);
    var g2 = el('div', { class: 'pw-grp' });
    g2.appendChild(el('button', { class: 'pw-mbtn', type: 'button', onclick: undoVertex }, ['↩ Undo point']));
    g2.appendChild(el('button', { class: 'pw-mbtn', type: 'button', onclick: redraw }, ['⟲ Redraw']));
    g2.appendChild(el('button', { class: 'pw-mbtn', type: 'button', onclick: function () { if (S.coords.length) PW.map.fitTo(S.coords); } }, ['⤢ Fit']));
    tools.appendChild(g1); tools.appendChild(g2);
    mw.appendChild(tools);

    var lg = el('div', { class: 'pw-mlegend' });
    lg.innerHTML =
      '<div><i class="pw-sw" style="background:#2a7fb8;opacity:.45"></i> Mapped pond</div>' +
      '<div><i class="pw-sw" style="background:#e8730a;opacity:.75"></i> Treatment zone</div>';
    mw.appendChild(lg);

    host.status = el('div', { class: 'pw-mstatus' });
    mw.appendChild(host.status);
    mid.appendChild(mw);

    host.steps = el('div', {});
    host.steps.style.marginTop = '14px';
    mid.appendChild(host.steps);
    wrap.appendChild(mid);

    /* right: live measurements */
    host.rail = el('div', { class: 'pw-rail-right' });
    wrap.appendChild(host.rail);

    return wrap;
  }

  /* ---------------------------------------------------------------- map events */

  function onPathChange(coords, flag) {
    S.coords = coords;
    if (flag === 'min_vertices') {
      setStatus('A pond outline needs at least three points — that one was kept.');
      return;
    }
    recompute();
  }

  function setMode(m) {
    PW.map.setMode(m);
    host.btnAdd.setAttribute('aria-pressed', m === 'add');
    host.btnEdit.setAttribute('aria-pressed', m === 'edit');
    setStatus(m === 'add'
      ? 'Click around the pond edge to drop points. Switch to Move / reshape when the outline is closed.'
      : 'Drag any point to move it. Drag a small midpoint handle to insert a point. Right-click a point to delete it. Drag inside the shape to move the whole outline.');
  }

  function undoVertex() {
    if (!S.coords.length) return;
    var c = S.coords.slice(0, -1);
    PW.map.setPath(c, false);
  }

  function redraw() {
    if (S.coords.length && !window.confirm('Clear the mapped outline? Depth, growth distance, product and notes are all kept.')) return;
    PW.map.clearPolygon();
    setMode('add');
  }

  function doSearch() {
    var q = host.search.value.trim();
    if (!q) { note(host.searchNote, 'warn', 'Enter an address, a place name, or coordinates as “latitude, longitude”.'); return; }
    U.clear(host.searchNote);
    setStatus('Searching…');
    PW.map.geocode(q, function (r) {
      if (r.ok) {
        S.address = r.address;
        note(host.searchNote, 'ok', 'Found: ' + r.address);
        setStatus('Zoom in until the pond fills the map, then click around its edge to drop points.');
        render();
      } else {
        note(host.searchNote, 'err', 'No match for that search. Try a street address, a nearby crossroads, or paste coordinates as “39.9781, -86.1189”.');
        setStatus('Location not found.');
      }
    });
  }

  function doLocate() {
    setStatus('Finding your location…');
    PW.map.locate(function (r) {
      if (r.ok) {
        S.address = S.address || (r.location.lat.toFixed(5) + ', ' + r.location.lng.toFixed(5));
        note(host.searchNote, 'ok', 'Centred on your location (accuracy about ' + Math.round(r.accuracy) + ' m). Zoom in and start clicking the pond edge.');
        setStatus('Centred on your location. Click around the pond edge to map it.');
        render();
      } else {
        note(host.searchNote, r.error === 'denied' ? 'warn' : 'err',
          r.error === 'denied'
            ? 'Location permission was declined. You can still search an address or pan the map by hand.'
            : r.error === 'unsupported'
              ? 'This browser does not support device location. Search an address instead.'
              : 'Could not get a location fix. Search an address instead.');
        setStatus('Search your address, then click around the pond edge.');
      }
    });
  }

  function setStatus(t) { host.status.textContent = t; }

  function note(target, kind, text) {
    U.clear(target);
    target.appendChild(el('div', { class: U.cls('note', kind), html: text }));
  }

  /* ---------------------------------------------------------------- compute */

  var recompute = U.debounce(function () {
    var growth = parseFloat(S.growthFt) || 0;
    geo = PW.geo.measure(S.coords, { growthFt: growth });
    PW.map.drawZone(geo);
    M = D.measures(geo, {
      pondDepthFt: S.pondDepthFt, zoneDepthFt: S.zoneDepthFt,
      depthMode: S.depthMode, growthHeightFt: S.growthHeightFt,
      sprayGal: S.sprayGal
    });
    RESULT = currentResult();
    render();
  }, 140);

  function recomputeNow() { recompute(); }

  function selectedProduct() {
    return PRODUCTS.filter(function (p) { return p.id === S.productId; })[0] || null;
  }
  function selectedRate() {
    var p = selectedProduct();
    if (!p) return null;
    return (p.rates || []).filter(function (r) { return r.id === S.rateId; })[0] || null;
  }

  function currentResult() {
    var p = selectedProduct(), r = selectedRate();
    if (!p || !r || !geo || !geo.valid) return null;
    return D.calc(p, r, M, {
      concentration: S.concentration,
      ratePick: S.ratePick,
      containerSize: S.containerSize
    });
  }

  /* ---------------------------------------------------------------- completion */

  function done(key) {
    switch (key) {
      case 'find': return !!(S.address || S.coords.length);
      case 'map': return S.coords.length >= 3 && geo && geo.valid;
      case 'confirm': return !!(geo && geo.valid && S.pondName);
      case 'depth': return parseFloat(S.pondDepthFt) > 0;
      case 'growth': return parseFloat(S.growthFt) > 0;
      case 'category': return !!S.objective;
      case 'product': return !!(S.productId && S.rateId);
      case 'zone': return !!(geo && geo.zoneSqft > 0);
      case 'dose': return !!(RESULT && RESULT.ok);
      case 'summary': return !!(RESULT && RESULT.ok);
    }
    return false;
  }

  /* ---------------------------------------------------------------- render */

  function render() {
    renderStepper();
    renderSteps();
    renderRail();
  }

  function renderStepper() {
    var box = U.clear(host.stepperBox);
    box.appendChild(el('h3', { text: 'Workflow' }));
    box.appendChild(el('p', { class: 'pw-sub', text: 'Jump to any step. Changing an earlier answer keeps everything else.' }));
    var ol = el('ol');
    STEPS.forEach(function (st) {
      var ok = done(st.key);
      var li = el('li', { class: ok ? U.cls('done') : '' });
      var b = el('button', {
        type: 'button',
        'aria-current': S.step === st.n ? 'step' : null,
        onclick: function () { S.step = st.n; goto(st.key); }
      }, [
        el('span', { class: 'pw-dot', text: ok ? '✓' : String(st.n) }),
        el('span', { text: st.label })
      ]);
      li.appendChild(b);
      ol.appendChild(li);
    });
    box.appendChild(ol);
    box.appendChild(el('div', { class: 'pw-btnrow' }, [
      el('button', { class: 'pw-btn pw-ghost pw-sm', type: 'button', onclick: PW.ui.openGlossary }, ['Glossary']),
      el('button', { class: 'pw-btn pw-ghost pw-sm', type: 'button', onclick: startOver }, ['New pond'])
    ]));
  }

  function startOver() {
    if (!window.confirm('Start a new pond? Unsaved work on this one is discarded.')) return;
    var acct = S.accountId;
    S = blank(); S.accountId = acct;
    PW.map.clearPolygon(); setMode('add');
    render(); recomputeNow();
  }

  function goto(key) {
    var n = document.getElementById('step-' + key);
    if (n) n.scrollIntoView({ behavior: 'smooth', block: 'start' });
    renderStepper();
  }

  function card(key, num, title, sub) {
    var c = el('div', { class: 'pw-card', id: 'step-' + key });
    c.appendChild(el('h3', {}, [el('span', { class: 'pw-num', text: String(num) }), title]));
    if (sub) c.appendChild(el('p', { class: 'pw-sub', html: sub }));
    return c;
  }

  function renderSteps() {
    var box = U.clear(host.steps);
    box.appendChild(stepMap());
    box.appendChild(stepConfirm());
    box.appendChild(stepDepth());
    box.appendChild(stepGrowth());
    box.appendChild(stepCategory());
    box.appendChild(stepProduct());
    box.appendChild(stepZone());
    box.appendChild(stepDose());
    box.appendChild(stepSummary());
  }

  /* ---- step 2 ---- */
  function stepMap() {
    var c = card('map', 2, 'Map the shoreline',
      'Click around the edge of the pond on the satellite image above. Three points is the minimum; ten to twenty usually traces a pond well. Then switch to <b>Move / reshape</b> to fine-tune.');
    var v = S.coords.length;
    c.appendChild(el('div', { class: 'pw-metrics' }, [
      metric('Points placed', v ? String(v) : '—')
    ]));
    var issues = (geo && geo.issues) || [];
    if (v > 0 && v < 3) {
      c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>Outline not closed yet</b>Add at least ' + (3 - v) + ' more point' + (3 - v === 1 ? '' : 's') + ' before an area can be calculated.' }));
    }
    if (issues.indexOf('self_intersect') >= 0) {
      c.appendChild(el('div', { class: 'pw-note pw-err', html: '<b>The outline crosses itself</b>Two shoreline segments overlap, which makes the area unreliable. Switch to Move / reshape and drag the crossing points apart, or redraw the outline.' }));
    }
    if (issues.indexOf('duplicate_points') >= 0) {
      c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>Points stacked on top of each other</b>Two or more points are within a foot of each other. They will not change the area much, but deleting the extras makes the outline easier to edit.' }));
    }
    if (issues.indexOf('too_small_for_grid') >= 0) {
      c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>Very small or very narrow shape</b>The mapped water is too narrow to model a shoreline band inside it, so the treatment zone falls back to the documented perimeter estimate. Check the outline is tracing the water and not a ditch or a shadow.' }));
    }
    return c;
  }

  /* ---- step 3 ---- */
  function stepConfirm() {
    var c = card('confirm', 3, 'Confirm the mapped area',
      'Give the pond a name so it can be saved and found again, and check the measurements against what you know about the pond.');
    if (!geo || !geo.valid) {
      c.appendChild(el('div', { class: 'pw-note pw-info', text: 'Measurements appear here once the outline has at least three points.' }));
      return c;
    }
    var r1 = el('div', { class: 'pw-row' });
    r1.appendChild(field('Pond name', input('text', S.pondName, function (v) { S.pondName = v; renderStepper(); }, 'e.g. North Irrigation Pond')));
    r1.appendChild(field('Property', input('text', S.property, function (v) { S.property = v; }, 'e.g. Harding Farms — north quarter')));
    c.appendChild(r1);

    var r2 = el('div', { class: 'pw-row' });
    r2.appendChild(field('Address or mapped location', input('text', S.address, function (v) { S.address = v; }, 'Address, or coordinates')));
    var u = PW.store.currentUser();
    var accts = PW.store.accounts().filter(function (a) { return PW.store.visibleAccountIds(u).indexOf(a.id) >= 0; });
    if (accts.length > 1) {
      r2.appendChild(field('Customer account', select(
        accts.map(function (a) { return { v: a.id, t: a.name }; }),
        S.accountId, function (v) { S.accountId = v; })));
    }
    c.appendChild(r2);

    c.appendChild(el('div', { class: 'pw-metrics', style: 'margin-top:12px' }, [
      metric('Total surface area', U.n0(geo.pondSqft) + ' <small>sq ft</small>'),
      metric('Total surface area', U.n2(geo.pondAcres) + ' <small>' + U.tip('surface acre') + 's</small>'),
      metric('Shoreline perimeter', U.n0(geo.perimeterFt) + ' <small>ft</small>'),
      metric('Widest point from shore', U.n0(geo.maxInscribedFt) + ' <small>ft</small>', 'mute')
    ]));
    c.appendChild(el('p', { class: 'pw-hint', html: 'Area and perimeter come from the mapped vertices on the satellite image, so their accuracy is the accuracy of your tracing. Compare the acreage against a figure you already trust before relying on it.' }));

    var tooSmall = geo.pondSqft < 400;
    if (tooSmall) c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>That is a very small area</b>The outline encloses under 400 square feet. Check that you traced the pond and not a feature next to it.' }));
    if (geo.pondAcres > 500) c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>That is a very large waterbody</b>Over 500 acres. Several of these labels have separate whole-lake directions, minimum treatment areas and potable-intake setbacks that this proof of concept does not model. Involve a SePRO Aquatic Specialist.' }));
    return c;
  }

  /* ---- step 4 ---- */
  function stepDepth() {
    var c = card('depth', 4, 'Enter average depth',
      'Depth drives every volume-based rate. Enter the ' + U.tip('average depth') + ' of the pond in feet — not the deepest spot.');
    var r = el('div', { class: 'pw-row' });
    r.appendChild(field('Pond average depth (ft)',
      input('number', S.pondDepthFt, function (v) { S.pondDepthFt = v; recomputeNow(); }, 'e.g. 5', { min: 0, step: 0.1, invalid: invalidDepth(S.pondDepthFt) })));

    var modeBox = el('div', {});
    modeBox.appendChild(el('label', { class: 'pw-fl', html: 'Depth used for the ' + U.tip('treatment zone') }));
    var seg = el('div', { class: 'pw-seg' });
    [['pond', 'Pond average'], ['zone', 'Enter separately'], ['product', 'Product-specific']].forEach(function (o) {
      seg.appendChild(el('button', {
        type: 'button', 'aria-pressed': S.depthMode === o[0],
        onclick: function () { S.depthMode = o[0]; recomputeNow(); }
      }, [o[1]]));
    });
    modeBox.appendChild(seg);
    r.appendChild(modeBox);
    c.appendChild(r);

    if (S.depthMode === 'zone') {
      c.appendChild(field('Treatment-zone average depth (ft)',
        input('number', S.zoneDepthFt, function (v) { S.zoneDepthFt = v; recomputeNow(); }, 'e.g. 3', { min: 0, step: 0.1, invalid: invalidDepth(S.zoneDepthFt) })));
      c.appendChild(el('p', { class: 'pw-hint', text: 'The shoreline band is usually shallower than the pond as a whole, so this normally lowers the calculated volume — and the dose with it.' }));
    } else if (S.depthMode === 'product') {
      c.appendChild(el('div', { class: 'pw-note pw-info', html: '<b>Product-specific depth</b>Each label states which depth its rate applies to — some say the average water depth of the treatment site, a few say the height of the plant growth in the water column, and a small number are only valid at one stated depth. Whichever the selected rate specifies is shown in the calculation in step 9. Where a label offers no depth of its own, the pond average depth is used.' }));
    } else {
      c.appendChild(el('p', { class: 'pw-hint', html: 'Using the pond average depth for the shoreline band assumes aquatic growth occupies the full average depth. That is often conservative — the shoreline is usually shallower. Choose <b>Enter separately</b> if you can estimate the band depth.' }));
    }

    var needsGrowthHeight = (function () {
      var r2 = selectedRate();
      return r2 && r2.depthSource === 'growth_height';
    })();
    if (needsGrowthHeight) {
      c.appendChild(field('Height of plant growth in the water column (ft)',
        input('number', S.growthHeightFt, function (v) { S.growthHeightFt = v; recomputeNow(); }, 'e.g. 2', { min: 0, step: 0.1 })));
      c.appendChild(el('div', { class: 'pw-note pw-info', html: '<b>This label sets the rate by ' + U.tip('plant growth height') + ', not water depth</b>Measure or estimate the distance from the bottom to the top of the target plants. The selected rate is applied per acre-foot of plant height, which is what the label directs.' }));
    }

    if (invalidDepth(S.pondDepthFt)) {
      c.appendChild(el('div', { class: 'pw-note pw-err', html: '<b>Check the depth</b>Depth must be a positive number of feet. Nothing has been changed for you — correct the entry above.' }));
    } else if (parseFloat(S.pondDepthFt) > 60) {
      c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>That is unusually deep for a pond</b>' + U.n1(S.pondDepthFt) + ' ft average. If that is right, carry on — but check you entered the average and not the maximum.' }));
    } else if (parseFloat(S.pondDepthFt) > 0 && parseFloat(S.pondDepthFt) < 1) {
      c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>Under one foot average depth</b>Several labels reduce or prohibit rates in water this shallow. Check the restrictions listed with the product you choose.' }));
    }
    if (S.depthMode === 'zone' && parseFloat(S.zoneDepthFt) > parseFloat(S.pondDepthFt) && parseFloat(S.pondDepthFt) > 0) {
      c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>The zone is deeper than the pond average</b>The shoreline band you entered (' + U.n1(S.zoneDepthFt) + ' ft) is deeper than the pond average (' + U.n1(S.pondDepthFt) + ' ft). That is possible but unusual. Nothing was changed — check both figures.' }));
    }
    return c;
  }

  function invalidDepth(v) {
    if (v === '' || v == null) return false;
    var n = parseFloat(v);
    return !isFinite(n) || n <= 0;
  }

  /* ---- step 5 ---- */
  function stepGrowth() {
    var c = card('growth', 5, 'Growth distance from shore',
      'How far does the aquatic growth reach out from the bank, on average, in feet? This becomes the width of the ' + U.tip('treatment zone') + '.');
    c.appendChild(field(U.tip('shoreline growth distance') + ' (ft)',
      input('number', S.growthFt, function (v) { S.growthFt = v; recomputeNow(); }, 'e.g. 15', { min: 0, step: 1, invalid: invalidDepth(S.growthFt) })));

    if (geo && geo.valid && geo.maxInscribedFt > 0) {
      c.appendChild(el('p', { class: 'pw-hint', html: 'For this outline, the furthest any point of open water sits from the bank is about <b>' + U.n0(geo.maxInscribedFt) + ' ft</b>. A growth distance at or above that treats the whole pond.' }));
    }

    var g = parseFloat(S.growthFt) || 0;
    if (geo && geo.valid && g > 0) {
      if (geo.wholePond) {
        c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>The zone now covers the entire pond</b>A growth distance of ' + U.n0(g) + ' ft reaches past the middle of this pond, so the treatment zone is the whole mapped surface (100%). If that is not what you meant, reduce the distance. If the whole pond genuinely needs treating, note that many labels restrict you to treating half the waterbody at a time — check the product restrictions.' }));
      }
      if (g > geo.maxInscribedFt * 3 && geo.maxInscribedFt > 0) {
        c.appendChild(el('div', { class: 'pw-note pw-err', html: '<b>That distance is far larger than the pond</b>' + U.n0(g) + ' ft of growth from shore in a pond whose centre is only ' + U.n0(geo.maxInscribedFt) + ' ft from the bank. Check the units — the field is in feet, not yards or metres. Nothing has been changed.' }));
      }
    }
    if (invalidDepth(S.growthFt)) {
      c.appendChild(el('div', { class: 'pw-note pw-err', html: '<b>Check the distance</b>Growth distance must be a positive number of feet.' }));
    }
    return c;
  }

  /* ---- step 6 ---- */
  function stepCategory() {
    var c = card('category', 6, 'Select growth category',
      'Pick the treatment objective. Only products whose label supports that objective are offered in the next step — nothing is suggested that its label does not cover.');
    var list = el('div', { class: 'pw-plist' });
    OBJECTIVES.forEach(function (o) {
      var count = D.productsFor(o.id, PRODUCTS).length;
      var b = el('button', {
        type: 'button', class: 'pw-pcard', 'aria-pressed': S.objective === o.id,
        onclick: function () {
          if (S.objective !== o.id) { S.objective = o.id; S.productId = ''; S.rateId = ''; S.concentration = null; }
          recomputeNow();
        }
      }, [
        el('h4', {}, [el('span', { text: o.label }), el('span', { class: 'pw-chip pw-grey', text: count + ' product' + (count === 1 ? '' : 's') })]),
        el('div', { class: 'pw-cat', text: o.desc })
      ]);
      list.appendChild(b);
    });
    c.appendChild(list);
    return c;
  }

  /* ---- step 7 ---- */
  function stepProduct() {
    var c = card('product', 7, 'Select product and rate', null);
    if (!S.objective) {
      c.appendChild(el('div', { class: 'pw-note pw-info', text: 'Choose a growth category in step 6 to see eligible products.' }));
      return c;
    }
    var eligible = D.productsFor(S.objective, PRODUCTS)
      .slice().sort(function (a, b) { return a.name.localeCompare(b.name); });

    c.appendChild(el('p', { class: 'pw-sub', html: '<b>' + eligible.length + '</b> products carry label directions for <b>' + U.esc(D.OBJ_LABEL[S.objective]) + '</b>. Every rate shown is taken from the product label in this project.' }));

    var list = el('div', { class: 'pw-plist' });
    eligible.forEach(function (p) {
      var rates = D.ratesFor(p, S.objective);
      var chips = el('div', { class: 'pw-chips' });
      chips.appendChild(el('span', { class: 'pw-chip pw-grey', text: p.formulation || 'product' }));
      chips.appendChild(el('span', { class: 'pw-chip', text: rates.length + ' labeled rate' + (rates.length === 1 ? '' : 's') }));
      var scopes = {};
      rates.forEach(function (r) { scopes[(D.MEASURE_META[r.measure] || {}).scope || '?'] = 1; });
      if (scopes.zone) chips.appendChild(el('span', { class: 'pw-chip pw-zone', text: 'treatment zone' }));
      if (scopes.pond) chips.appendChild(el('span', { class: 'pw-chip pw-blue', text: 'whole pond' }));
      if (scopes.spray) chips.appendChild(el('span', { class: 'pw-chip pw-grey', text: 'spray solution' }));
      if (!p.isPesticide) chips.appendChild(el('span', { class: 'pw-chip pw-grey', text: 'not a pesticide' }));
      if (p.adjuvantRequirement) chips.appendChild(el('span', { class: 'pw-chip pw-red', text: 'adjuvant required' }));

      var b = el('button', {
        type: 'button', class: 'pw-pcard', 'aria-pressed': S.productId === p.id,
        onclick: function () {
          if (S.productId !== p.id) {
            S.productId = p.id;
            var rr = D.ratesFor(p, S.objective);
            S.rateId = rr.length ? rr[0].id : '';
            S.concentration = null; S.ratePick = 'high';
          }
          recomputeNow();
        }
      }, [
        el('h4', {}, [el('span', { text: p.name })]),
        el('div', { class: 'pw-cat', text: p.category + (p.epaReg ? ' · ' + p.epaReg : '') }),
        chips
      ]);
      list.appendChild(b);
    });
    c.appendChild(list);

    var p = selectedProduct();
    if (p) c.appendChild(rateChooser(p));
    return c;
  }

  function rateChooser(p) {
    var box = el('div', { style: 'margin-top:14px;border-top:1px solid var(--line-2);padding-top:14px' });
    box.appendChild(el('h4', { text: p.name + ' — labeled rates for ' + D.OBJ_LABEL[S.objective], style: 'font-size:14px;margin-bottom:8px' }));

    var rates = D.ratesFor(p, S.objective);
    var sel = el('div', { class: 'pw-plist' });
    rates.forEach(function (r) {
      var meta = D.MEASURE_META[r.measure] || {};
      var rangeText;
      if (r.concentration) {
        rangeText = (r.min != null ? D.fmt(r.min) + '–' : '') + D.fmt(Math.min(r.max != null ? r.max : Infinity, r.concentration.labelMaxConc != null ? r.concentration.labelMaxConc : Infinity)) + ' ' + r.concentration.concUnit;
      } else if (r.min != null && r.max != null && Math.abs(r.max - r.min) > 1e-9) {
        rangeText = D.fmt(r.min) + '–' + D.fmt(r.max) + ' ' + D.unitAbbr(r.unit) + ' per ' + D.perUnitText(r.measure);
      } else {
        var one = r.max != null ? r.max : r.typical;
        rangeText = (one != null ? D.fmt(one) + ' ' + D.unitAbbr(r.unit) + ' per ' + D.perUnitText(r.measure) : 'no numeric rate on label');
      }
      var chips = el('div', { class: 'pw-chips' });
      chips.appendChild(el('span', {
        class: U.cls('chip', meta.scope === 'pond' ? 'blue' : meta.scope === 'zone' ? 'zone' : 'grey'),
        text: meta.label || r.measure
      }));
      if (r.calculable === false) chips.appendChild(el('span', { class: 'pw-chip pw-red', text: 'not calculable' }));
      if (r.depthValidity) chips.appendChild(el('span', { class: 'pw-chip pw-red', text: 'only valid at ' + r.depthValidity.equals + ' ft' }));
      if (r.requiresSprayVolume) chips.appendChild(el('span', { class: 'pw-chip pw-grey', text: 'needs spray volume' }));
      if (r.aliasOf) chips.appendChild(el('span', { class: 'pw-chip pw-red', text: 'no rate on label for this objective' }));

      sel.appendChild(el('button', {
        type: 'button', class: 'pw-pcard', 'aria-pressed': S.rateId === r.id,
        onclick: function () { S.rateId = r.id; S.concentration = null; S.ratePick = 'high'; recomputeNow(); }
      }, [
        el('h4', {}, [el('span', { text: r.label }), el('span', { class: 'pw-chip', text: rangeText })]),
        r.notes ? el('div', { class: 'pw-cat', text: String(r.notes).slice(0, 240) + (String(r.notes).length > 240 ? '…' : '') }) : null
      ]));
    });
    box.appendChild(sel);

    var r = selectedRate();
    if (r) box.appendChild(rateAdjust(p, r));
    return box;
  }

  function rateAdjust(p, r) {
    var box = el('div', { style: 'margin-top:12px' });

    if (r.concentration) {
      var c = r.concentration;
      var lo = r.min != null ? r.min : 0;
      var hi = Math.min(r.max != null ? r.max : Infinity, c.labelMaxConc != null ? c.labelMaxConc : Infinity);
      if (!isFinite(hi)) hi = r.max || lo;
      var cur = S.concentration != null ? parseFloat(S.concentration) : (r.typical != null ? r.typical : hi);
      if (cur > hi) cur = hi;
      var step = hi <= 2 ? 0.05 : hi <= 20 ? 0.5 : hi <= 200 ? 5 : 10;
      var w = el('div', { class: 'pw-rangewrap' });
      w.appendChild(el('div', { class: 'pw-top' }, [
        el('span', { html: 'Target ' + U.esc(c.concLabel) }),
        el('b', { text: D.fmt(cur) + ' ' + c.concUnit })
      ]));
      var range = el('input', { type: 'range', min: lo, max: hi, step: step, value: cur });
      range.addEventListener('input', function () { S.concentration = parseFloat(this.value); recomputeNow(); });
      w.appendChild(range);
      w.appendChild(el('div', { class: 'pw-ends' }, [
        el('span', { text: 'label minimum ' + D.fmt(lo) + ' ' + c.concUnit }),
        el('span', { text: 'label maximum ' + D.fmt(hi) + ' ' + c.concUnit })
      ]));
      box.appendChild(w);
      box.appendChild(el('p', { class: 'pw-hint', html: 'The slider cannot be pushed past the maximum labeled concentration. Conversion used: <i>' + U.esc(c.formula) + '</i>' }));
    } else if (r.min != null && r.max != null && Math.abs(r.max - r.min) > 1e-9) {
      var w2 = el('div', {});
      w2.appendChild(el('label', { class: 'pw-fl', html: 'Where in the labeled ' + U.tip('application rate') + ' range?' }));
      var seg = el('div', { class: 'pw-seg' });
      [['low', 'Low — ' + D.fmt(r.min)], ['mid', 'Middle — ' + D.fmt((r.min + r.max) / 2)], ['high', 'High — ' + D.fmt(r.max)]].forEach(function (o) {
        var isMid = o[0] === 'mid';
        var pressed = isMid ? (typeof S.ratePick === 'number') : S.ratePick === o[0];
        seg.appendChild(el('button', {
          type: 'button', 'aria-pressed': pressed,
          onclick: function () { S.ratePick = isMid ? (r.min + r.max) / 2 : o[0]; recomputeNow(); }
        }, [o[1] + ' ' + D.unitAbbr(r.unit)]));
      });
      w2.appendChild(seg);
      box.appendChild(w2);
      box.appendChild(el('p', { class: 'pw-hint', text: 'Labels generally direct the low end for light, early-season growth and the high end for dense, mature growth or difficult species. The high end is the maximum labeled rate — the calculator will not go above it.' }));
    } else {
      box.appendChild(el('p', { class: 'pw-hint', text: 'This label states a single rate for this scenario, so there is no range to choose within.' }));
    }

    if (r.requiresSprayVolume) {
      box.appendChild(field('Spray solution you plan to mix (gallons)',
        input('number', S.sprayGal, function (v) { S.sprayGal = v; recomputeNow(); }, 'e.g. 50', { min: 0, step: 1 })));
      box.appendChild(el('p', { class: 'pw-hint', text: 'Percent-solution treatments are measured against the tank, not the pond. The pond area cannot tell us how much solution you will mix, so enter it here.' }));
    }

    box.appendChild(field('Container size you are buying (' + D.unitAbbr(r.concentration ? r.concentration.productUnit : r.unit) + ', optional)',
      input('number', S.containerSize, function (v) { S.containerSize = v; recomputeNow(); }, 'e.g. 2.5', { min: 0, step: 0.1 })));
    if (!(p.packages || []).length) {
      box.appendChild(el('p', { class: 'pw-hint', text: 'This label does not state a container size, so container counts cannot be taken from label data. Enter the size you are buying and the count is calculated.' }));
    }

    box.appendChild(productLabelPanel(p, r));
    return box;
  }

  function productLabelPanel(p, r) {
    var d = el('details', { class: 'pw-disc' });
    d.appendChild(el('summary', { text: 'Label information for ' + p.name }));
    var b = el('div', { class: 'pw-body' });

    b.appendChild(kvList([
      ['EPA registration', p.epaReg],
      ['Active ingredients', p.activeIngredients],
      ['Formulation', p.formulation],
      ['Label file', p.labelFile]
    ]));

    if (p.adjuvantRequirement) {
      b.appendChild(el('div', { class: 'pw-note pw-err', html: '<b>Adjuvant / surfactant requirement</b>' + U.esc(p.adjuvantRequirement) }));
    }
    if (r.depthRule) {
      b.appendChild(el('div', { class: 'pw-note pw-info', html: '<b>Depth the label directs for this rate</b>' + U.esc(r.depthRule) }));
    }
    if (r.notes) {
      b.appendChild(el('div', { class: 'pw-note pw-info', html: '<b>Rate notes from the label</b>' + U.esc(r.notes) }));
    }
    if ((p.hardMaximums || []).length) {
      b.appendChild(el('dt', { text: 'Maximum rates and “do not exceed” statements' }));
      b.appendChild(ul(p.hardMaximums));
    }
    if (p.depthLimits) { b.appendChild(el('dt', { text: 'Depth limits' })); b.appendChild(el('dd', { text: p.depthLimits })); }
    var rest = p.restrictions || {};
    var restRows = [];
    [['potable', 'Potable / drinking water'], ['irrigation', 'Irrigation'], ['livestock', 'Livestock watering'],
    ['swimming', 'Swimming'], ['fishing_fish_consumption', 'Fishing / fish consumption'], ['other', 'Other']]
      .forEach(function (k) { if (rest[k[0]]) restRows.push([k[1], rest[k[0]]]); });
    if (restRows.length) { b.appendChild(el('dt', { text: 'Water-use restrictions' })); b.appendChild(kvList(restRows)); }
    if (p.retreatmentInterval) { b.appendChild(el('dt', { text: 'Retreatment interval' })); b.appendChild(el('dd', { text: p.retreatmentInterval })); }
    if (p.partialTreatmentRule) { b.appendChild(el('dt', { text: 'Partial treatment rule' })); b.appendChild(el('dd', { text: p.partialTreatmentRule })); }
    if ((p.requiredNotes || []).length) { b.appendChild(el('dt', { text: 'Required application notes' })); b.appendChild(ul(p.requiredNotes)); }
    if ((p.dataGaps || []).length) {
      b.appendChild(el('dt', { text: 'What this label does not tell us' }));
      b.appendChild(ul(p.dataGaps));
    }
    d.appendChild(b);
    return d;
  }

  function ul(items) {
    var u = el('ul');
    (items || []).forEach(function (i) { u.appendChild(el('li', { text: String(i) })); });
    return u;
  }
  function kvList(rows) {
    var w = el('div');
    (rows || []).forEach(function (r) {
      if (!r[1]) return;
      w.appendChild(el('dt', { text: r[0] }));
      w.appendChild(el('dd', { text: String(r[1]) }));
    });
    return w;
  }

  /* ---- step 8 ---- */
  function stepZone() {
    var c = card('zone', 8, 'Review the treatment zone',
      'The orange band on the map is the water the calculator is treating. It is measured inward from the shoreline you mapped and is clipped to the pond boundary.');
    if (!geo || !geo.valid) {
      c.appendChild(el('div', { class: 'pw-note pw-info', text: 'Map the pond outline first.' }));
      return c;
    }
    var g = parseFloat(S.growthFt) || 0;
    if (g <= 0) {
      c.appendChild(el('div', { class: 'pw-note pw-info', text: 'Enter a growth distance in step 5 to see the treatment zone.' }));
      return c;
    }
    c.appendChild(el('div', { class: 'pw-metrics' }, [
      metric('Treatment-zone area', U.n0(geo.zoneSqft) + ' <small>sq ft</small>', 'zone'),
      metric('Treatment-zone area', U.n2(geo.zoneAcres) + ' <small>acres</small>', 'zone'),
      metric('Share of pond surface treated', U.n1(geo.zonePct) + ' <small>%</small>', 'zone'),
      metric('Untreated open water', U.n0(geo.coreSqft) + ' <small>sq ft</small>', 'mute')
    ]));
    var bar = el('div', { class: 'pw-bar' });
    bar.appendChild(el('i', { style: 'width:' + Math.min(100, geo.zonePct).toFixed(1) + '%' }));
    c.appendChild(bar);

    var depthUsed = S.depthMode === 'zone' ? parseFloat(S.zoneDepthFt) : parseFloat(S.pondDepthFt);
    if (depthUsed > 0) {
      c.appendChild(el('div', { class: 'pw-metrics', style: 'margin-top:9px' }, [
        metric('Treatment-zone volume', U.n2(geo.zoneAcres * depthUsed) + ' <small>' + U.tip('acre-foot') + '</small>', 'zone big'),
        metric('Treatment-zone volume', U.n0(geo.zoneAcres * depthUsed * PW.geo.GAL_PER_ACREFT) + ' <small>gallons</small>', 'zone'),
        metric('Depth used for this volume', U.n1(depthUsed) + ' <small>ft — ' + (S.depthMode === 'zone' ? 'zone depth you entered' : 'pond average') + '</small>', 'mute')
      ]));
    } else {
      c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>No depth yet</b>Zone volume needs an average depth — go back to step 4.' }));
    }

    var m = el('details', { class: 'pw-disc' });
    m.appendChild(el('summary', { text: 'How the treatment zone was calculated' }));
    m.appendChild(el('div', { class: 'pw-body', html: zoneMethodHtml() }));
    c.appendChild(m);

    if (geo.wholePond) {
      c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>Whole pond selected</b>The growth distance reaches past the centre, so the zone is the entire pond. Many labels restrict treatment to half the waterbody at a time to protect dissolved oxygen — check the restrictions on the product you selected.' }));
    }
    return c;
  }

  function zoneMethodHtml() {
    if (!geo) return '';
    var naive = geo.naiveZoneSqft;
    var diff = naive > 0 && geo.zoneSqft > 0 ? ((naive - geo.zoneSqft) / geo.zoneSqft * 100) : 0;
    var h = '';
    if (geo.method === 'inward_buffer_distance_field') {
      h += '<p><b>Method: inward shoreline buffer, measured on a distance grid.</b> This is a true inward buffer, not a perimeter estimate. '
        + 'The mapped vertices are projected onto a local plane in feet, a uniform grid of about '
        + U.n0(geo.gridCells) + ' sample points (roughly ' + U.n1(geo.cellFt) + ' ft apart) is laid over the outline, and every point is tested for '
        + 'whether it falls inside the pond and how far it sits from the nearest shoreline segment. '
        + 'Points inside the pond within ' + U.n0(parseFloat(S.growthFt) || 0) + ' ft of the shore are treatment zone; the rest of the interior is untreated open water. '
        + 'The two counts are then scaled so they add up to the exact surface area of the mapped polygon, which cancels out the grid\'s rounding. '
        + 'Because the sampling only ever looks inside the outline, the zone cannot extend past the pond boundary.</p>';
      h += '<p>The inner edge you see on the map is the same ' + U.n0(parseFloat(S.growthFt) || 0)
        + '-foot contour, traced with marching squares, so the drawing and the number come from one calculation.</p>';
      if (naive > 0) {
        h += '<p><b>For comparison:</b> the simple estimate of perimeter × distance gives '
          + U.n0(naive) + ' sq ft, which is ' + U.n1(Math.abs(diff)) + '% ' + (diff >= 0 ? 'higher' : 'lower')
          + ' than the buffer result of ' + U.n0(geo.zoneSqft) + ' sq ft. '
          + 'Perimeter × distance always overstates the band on a convex shoreline, because it double-counts the corners, and it can exceed the pond entirely on a small pond.</p>';
      }
    } else {
      h += '<p><b>Method: documented perimeter estimate.</b> The mapped water was too narrow to fit a sampling grid, so the zone is estimated as '
        + 'shoreline perimeter × growth distance, capped at the total pond area. This is an estimate and is labeled as one throughout.</p>';
    }
    h += '<p><b>This is an estimate.</b> Its accuracy depends on how carefully the shoreline was traced, the quality and date of the satellite imagery, '
      + 'and how well a single average growth distance describes a shoreline where growth is patchy.</p>';
    return h;
  }

  /* ---- step 9 ---- */
  function stepDose() {
    var c = card('dose', 9, 'View the dosage calculation', null);
    if (!S.productId || !S.rateId) {
      c.appendChild(el('div', { class: 'pw-note pw-info', text: 'Select a product and a labeled rate in step 7.' }));
      return c;
    }
    var p = selectedProduct(), r = selectedRate();
    var res = RESULT;
    if (!res) {
      c.appendChild(el('div', { class: 'pw-note pw-info', text: 'Finish mapping the pond to calculate a dosage.' }));
      return c;
    }
    if (!res.ok) {
      c.appendChild(el('div', { class: 'pw-note pw-err', html: '<b>A dosage cannot be calculated</b>' + U.esc(res.blocked) }));
      return c;
    }

    c.appendChild(el('p', { class: 'pw-sub', html: '<b>' + U.esc(p.name) + '</b> · ' + U.esc(r.label) }));

    if (res.mandatoryNote) {
      c.appendChild(el('div', { class: 'pw-note pw-err', html: '<b>What this number is, and is not</b>' + U.esc(res.mandatoryNote) }));
    }

    /* the transparent calculation */
    var cb = el('div', { class: 'pw-calcbox' });
    res.steps.forEach(function (st) {
      cb.appendChild(el('div', { class: 'pw-calcline', text: st.text }));
      if (st.note) cb.appendChild(el('p', { class: 'pw-hint', text: st.note }));
    });
    cb.appendChild(el('div', { class: 'pw-calcline' }, [
      el('b', { text: D.fmt(res.measure.value) + ' ' + res.measure.meta.unit }),
      el('span', { class: 'pw-op', text: ' × ' }),
      el('b', { text: D.fmt(res.rateUsed) + ' ' + res.rateUnitText }),
      el('span', { class: 'pw-op', text: ' = ' }),
      el('b', { text: D.fmt(res.amount) + ' ' + res.unitAbbr })
    ]));
    cb.appendChild(el('p', { class: 'pw-hint', html: 'Measured quantity: <b>' + U.esc(res.measure.meta.label) + '</b> of the ' + U.esc(res.measure.scopeLabel)
      + (res.measure.depthLabel ? ', using the <b>' + U.esc(res.measure.depthLabel) + '</b> of ' + U.n1(res.measure.depthUsed) + ' ft' : '') + '.' }));

    cb.appendChild(el('div', { class: 'pw-result' }, [
      el('div', {}, [
        el('div', { class: 'pw-lab', text: 'Exact calculated quantity' }),
        el('div', { class: 'pw-amt', html: D.fmt(res.amount) + ' <small>' + res.unitAbbr + '</small>' })
      ]),
      res.hasRange ? el('div', { style: 'text-align:right' }, [
        el('div', { class: 'pw-lab', text: 'Labeled range for this measurement' }),
        el('div', { style: 'font-weight:700;font-size:16px' , text: D.fmt(res.amountLow) + ' – ' + D.fmt(res.amountHigh) + ' ' + res.unitAbbr })
      ]) : null
    ]));
    c.appendChild(cb);

    /* clamps first — they are the most important thing on the screen */
    res.clamps.forEach(function (cl) {
      c.appendChild(el('div', { class: 'pw-note pw-err', html: '<b>Reduced to the label maximum</b>The '
        + U.esc(cl.what) + ' was reduced from ' + U.esc(cl.from) + ' to ' + U.esc(cl.to)
        + '. Label statement: “' + U.esc(cl.reason) + '”' }));
    });
    res.warnings.forEach(function (w) {
      c.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>Check this</b>' + U.esc(w.text) }));
    });

    /* purchase quantities */
    var pk = res.packaging;
    var tbl = el('table', { class: 'pw-t' });
    tbl.innerHTML = '<thead><tr><th>Quantity</th><th class="pw-n">Amount</th></tr></thead>';
    var tb = el('tbody');
    tb.appendChild(trow('Exact calculated quantity', D.fmt(res.amount) + ' ' + res.unitAbbr));
    if (res.hasRange) {
      tb.appendChild(trow('At the label minimum rate', D.fmt(res.amountLow) + ' ' + res.unitAbbr));
      tb.appendChild(trow('At the maximum labeled rate', D.fmt(res.amountHigh) + ' ' + res.unitAbbr));
    }
    if (pk.available) {
      tb.appendChild(trow('Container size', D.fmt(pk.containerSize) + ' ' + pk.unit + ' (' + pk.source + ')'));
      tb.appendChild(trow('Containers required', String(pk.count)));
      tb.appendChild(trow('Practical purchase quantity', D.fmt(pk.purchaseAmount) + ' ' + pk.unit));
      tb.appendChild(trow('Estimated unused product remaining', D.fmt(pk.leftover) + ' ' + pk.unit));
    }
    tbl.appendChild(tb);
    c.appendChild(tbl);
    if (!pk.available && pk.reason) c.appendChild(el('p', { class: 'pw-hint', text: pk.reason }));

    var cart = cartBlock(p, res);
    if (cart) c.appendChild(cart);

    /* seasonal budgets */
    (res.season || []).forEach(function (s) {
      var pct = Math.min(100, s.pctOfBudget);
      var box = el('div', { class: 'pw-note pw-info' });
      box.innerHTML = '<b>Season budget for this pond</b>' + U.esc(s.text)
        + '<br>For the area you mapped that works out to about <b>' + D.fmt(s.budget) + ' ' + s.unit
        + '</b> for the whole season. This single application uses <b>' + D.fmt(s.usedByThis) + ' ' + s.unit
        + '</b>, or ' + U.n1(pct) + '% of it.';
      var bar = el('div', { class: 'pw-bar' });
      bar.appendChild(el('i', { style: 'width:' + pct.toFixed(1) + '%' }));
      box.appendChild(bar);
      c.appendChild(box);
    });

    /* the ceilings that were checked */
    if ((res.appliedCaps || []).length) {
      var d = el('details', { class: 'pw-disc' });
      d.appendChild(el('summary', { text: 'Label ceilings checked against this calculation (' + res.appliedCaps.length + ')' }));
      var body = el('div', { class: 'pw-body' });
      body.appendChild(ul(res.appliedCaps.map(function (cp) {
        return cp.text + '  [checked: ' + D.fmt(res.rateUsed) + ' vs. ' + D.fmt(cp.max) + ' ' + D.unitAbbr(cp.unit) + ' ' + cp.basis.replace(/_/g, ' ') + ', ' + cp.scope + ']';
      })));
      d.appendChild(body);
      c.appendChild(d);
    }

    /* restrictions that must be read */
    var must = [];
    if (p.adjuvantRequirement) must.push('Adjuvant / surfactant: ' + p.adjuvantRequirement);
    (p.requiredNotes || []).slice(0, 6).forEach(function (n) { must.push(n); });
    if (must.length) {
      var nb = el('div', { class: 'pw-note pw-warn' });
      nb.appendChild(el('b', { text: 'Application notes and restrictions you must read before applying' }));
      nb.appendChild(ul(must));
      c.appendChild(nb);
    }

    c.appendChild(el('div', { class: 'pw-btnrow' }, [
      el('button', { class: 'pw-btn', type: 'button', onclick: savePondAndCalc }, [S.pondId ? 'Save calculation' : 'Save pond and calculation']),
      el('button', { class: 'pw-btn pw-sec', type: 'button', onclick: function () { S.step = 10; goto('summary'); } }, ['Go to summary'])
    ]));
    host.saveNote = el('div', {});
    c.appendChild(host.saveNote);
    return c;
  }


  /* ---- add to cart (Shopify only) ---- */

  function cartBlock(product, res) {
    if (!PW.shop || !PW.shop.linkFor) return null;
    var link = PW.shop.linkFor(product.id);
    var pk = res.packaging;

    var box = el('div', { style: 'margin-top:13px;border-top:1px solid var(--line-2);padding-top:13px' });
    box.appendChild(el('h4', { text: 'Order this product', style: 'font-size:14px' }));

    if (!link || !link.variantId) {
      box.appendChild(el('p', {
        class: 'pw-hint',
        text: product.name + ' is not linked to a product in this store, so it cannot be added to the cart. ' +
          'A store administrator links it in the theme editor by adding a product row to this section.'
      }));
      return box;
    }

    if (!pk.available) {
      box.appendChild(el('p', {
        class: 'pw-hint',
        html: 'The number of containers cannot be worked out yet, because neither the label nor the store ' +
          'states a pack size for ' + U.esc(link.title || product.name) + '. Enter the container size above ' +
          'and the quantity will be calculated.'
      }));
      box.appendChild(el('p', {}, [
        el('a', { href: link.url, target: '_blank', rel: 'noopener' }, ['View ' + (link.title || product.name)])
      ]));
      return box;
    }

    var qtyWrap = el('div', { class: 'pw-row' });
    var qtyInput = el('input', { type: 'number', min: 1, step: 1, value: String(pk.count) });
    qtyWrap.appendChild(field('Containers', qtyInput));
    var summary = el('div', { class: 'pw-metrics' }, [
      metric('Pack size', D.fmt(pk.containerSize) + ' <small>' + pk.unit + '</small>'),
      link.price != null ? metric('Price each', PW.shop.money(link.price)) : null
    ].filter(Boolean));
    qtyWrap.appendChild(summary);
    box.appendChild(qtyWrap);

    box.appendChild(el('p', {
      class: 'pw-hint',
      html: 'The calculation needs <b>' + D.fmt(res.amount) + ' ' + U.esc(res.unitAbbr) + '</b>, so <b>' +
        pk.count + '</b> container' + (pk.count === 1 ? '' : 's') + ' of ' + D.fmt(pk.containerSize) + ' ' +
        U.esc(pk.unit) + ' covers it, leaving about ' + D.fmt(pk.leftover) + ' ' + U.esc(pk.unit) + ' spare. ' +
        'Pack size source: ' + U.esc(pk.source) + '.'
    }));

    var msg = el('div', {});
    var btn = el('button', {
      class: 'pw-btn', type: 'button', disabled: !link.available,
      onclick: function () {
        var n = parseInt(qtyInput.value, 10) || 1;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        PW.shop.addToCart(product.id, n, function (r) {
          btn.disabled = false;
          btn.textContent = r.ok ? 'Add more' : 'Add to cart';
          U.clear(msg);
          msg.appendChild(el('div', {
            class: U.cls('note', r.ok ? 'ok' : 'err'),
            html: r.ok
              ? 'Added ' + r.qty + ' × ' + U.esc(r.title || product.name) + ' to the cart.'
              : r.error === 'unavailable' ? 'That product is out of stock in this store.'
                : r.error === 'unlinked' ? 'That product is not linked to this store.'
                  : 'The cart rejected the item: ' + U.esc(r.error)
          }));
        });
      }
    }, [link.available ? 'Add to cart' : 'Out of stock']);

    var row = el('div', { class: 'pw-btnrow' }, [btn]);
    if (link.url) {
      row.appendChild(el('a', { class: 'pw-btn pw-ghost', href: link.url, target: '_blank', rel: 'noopener' },
        ['View product page']));
    }
    box.appendChild(row);
    box.appendChild(msg);
    box.appendChild(el('p', {
      class: 'pw-hint',
      text: 'Adding to the cart does not check the label restrictions for you. Read the application notes above ' +
        'and the label itself before applying anything.'
    }));
    return box;
  }

  function trow(k, v) {
    return el('tr', {}, [el('td', { text: k }), el('td', { class: 'pw-n', text: v })]);
  }

  /* ---- step 10 ---- */
  function stepSummary() {
    var c = card('summary', 10, 'Generate the treatment summary',
      'Produces a one-page summary with the satellite image, the mapped boundary and treatment zone, every input, the calculation, the assumptions and the label disclaimer. Print it or save it as a PDF from the print dialog.');
    var ready = RESULT && RESULT.ok;
    c.appendChild(field('Notes for the summary', el('textarea', {
      placeholder: 'Site conditions, access, what you observed, who you spoke to…',
      oninput: function () { S.notes = this.value; }
    })));
    c.lastChild.querySelector('textarea').value = S.notes || '';

    var ph = el('div', {});
    ph.appendChild(el('label', { class: 'pw-fl', text: 'Photos (kept on this device only)' }));
    var file = el('input', { type: 'file', accept: 'image/*', multiple: true });
    file.addEventListener('change', function () { addPhotos(this.files); });
    ph.appendChild(file);
    if (S.photos.length) {
      var strip = el('div', { style: 'display:flex;gap:6px;flex-wrap:wrap;margin-top:8px' });
      S.photos.forEach(function (src, i) {
        var w = el('div', { style: 'position:relative' });
        w.appendChild(el('img', { src: src, style: 'width:76px;height:56px;object-fit:cover;border-radius:8px' }));
        w.appendChild(el('button', {
          class: 'pw-btn pw-danger pw-sm', type: 'button', style: 'position:absolute;top:-6px;right:-6px;padding:1px 6px;min-height:0',
          onclick: function () { S.photos.splice(i, 1); render(); }
        }, ['×']));
        strip.appendChild(w);
      });
      ph.appendChild(strip);
    }
    c.appendChild(ph);

    c.appendChild(el('div', { class: 'pw-btnrow' }, [
      el('button', { class: 'pw-btn', type: 'button', disabled: !ready, onclick: function () { PW.ui.showReport(buildReportModel()); } }, ['Generate summary']),
      el('button', { class: 'pw-btn pw-sec', type: 'button', onclick: savePondAndCalc }, [S.pondId ? 'Save calculation' : 'Save pond and calculation'])
    ]));
    if (!ready) c.appendChild(el('div', { class: 'pw-note pw-info', text: 'Complete steps 1 through 9 to generate a summary.' }));
    return c;
  }

  function addPhotos(files) {
    Array.prototype.slice.call(files).slice(0, 4).forEach(function (f) {
      if (!/^image\//.test(f.type) || f.size > 4.5 * 1024 * 1024) return;
      var fr = new FileReader();
      fr.onload = function () { S.photos.push(fr.result); render(); };
      fr.readAsDataURL(f);
    });
  }

  /* ---------------------------------------------------------------- save */

  function savePondAndCalc() {
    if (!geo || !geo.valid) { note(host.saveNote || host.steps, 'err', 'Map the pond outline first.'); return; }
    if (!S.pondName) { note(host.saveNote || host.steps, 'warn', 'Give the pond a name in step 3 so it can be found again.'); goto('confirm'); return; }
    var id = PW.store.savePond({
      id: S.pondId, accountId: S.accountId, name: S.pondName, property: S.property,
      address: S.address, coords: S.coords, depthFt: parseFloat(S.pondDepthFt) || null,
      notes: S.notes, photos: S.photos
    });
    S.pondId = id;
    var msg = 'Pond saved.';
    if (RESULT && RESULT.ok) {
      var cid = PW.store.saveCalc({
        id: null, pondId: id, accountId: S.accountId, date: U.today(),
        objective: S.objective, productId: S.productId, productName: selectedProduct().name,
        rateId: S.rateId, rateLabel: selectedRate().label,
        pondAcres: geo.pondAcres, zoneAcres: geo.zoneAcres,
        zoneAcreFt: geo.zoneAcres * (S.depthMode === 'zone' ? parseFloat(S.zoneDepthFt) || 0 : parseFloat(S.pondDepthFt) || 0),
        depthFt: parseFloat(S.pondDepthFt) || null, growthFt: parseFloat(S.growthFt) || null,
        amount: RESULT.amount, unit: RESULT.unit, notes: S.notes
      });
      S.savedCalcId = cid;
      msg += ' Calculation recorded in the treatment history.';
    }
    note(host.saveNote || host.steps, 'ok', msg + (PW.store.isPersistent() ? '' : ' <b>Note:</b> this browser is blocking local storage, so it will not survive a reload.'));
    render();
  }

  /* ---------------------------------------------------------------- right rail */

  function renderRail() {
    var box = U.clear(host.rail);

    var c1 = el('div', { class: 'pw-card' });
    c1.appendChild(el('h3', { text: 'Pond measurements' }));
    if (!geo || !geo.valid) {
      c1.appendChild(el('div', { class: 'pw-empty', text: 'Map at least three points around the pond to see measurements.' }));
    } else {
      var depth = parseFloat(S.pondDepthFt) || 0;
      c1.appendChild(el('div', { class: 'pw-metrics' }, [
        metric('Surface area', U.n2(geo.pondAcres) + ' <small>acres</small>', 'big'),
        metric('Surface area', U.n0(geo.pondSqft) + ' <small>sq ft</small>'),
        metric('Shoreline perimeter', U.n0(geo.perimeterFt) + ' <small>ft</small>'),
        metric('Average depth', depth ? U.n1(depth) + ' <small>ft</small>' : '— <small>enter in step 4</small>', depth ? '' : 'mute'),
        metric('Total pond volume', depth ? U.n2(geo.pondAcres * depth) + ' <small>acre-ft</small>' : '—', depth ? 'big' : 'mute'),
        metric('Total pond volume', depth ? U.n0(geo.pondAcres * depth * PW.geo.GAL_PER_ACREFT) + ' <small>gallons</small>' : '—', depth ? '' : 'mute')
      ]));
    }
    box.appendChild(c1);

    if (geo && geo.valid && geo.zoneSqft > 0) {
      var c2 = el('div', { class: 'pw-card' });
      c2.appendChild(el('h3', { text: 'Treatment zone' }));
      c2.appendChild(el('p', { class: 'pw-sub', text: 'Estimated — inward from the mapped shoreline, clipped to the pond boundary.' }));
      var dz = S.depthMode === 'zone' ? parseFloat(S.zoneDepthFt) || 0 : parseFloat(S.pondDepthFt) || 0;
      c2.appendChild(el('div', { class: 'pw-metrics' }, [
        metric('Zone area', U.n2(geo.zoneAcres) + ' <small>acres</small>', 'zone big'),
        metric('Zone area', U.n0(geo.zoneSqft) + ' <small>sq ft</small>', 'zone'),
        metric('Share of pond treated', U.n1(geo.zonePct) + ' <small>%</small>', 'zone'),
        metric('Zone volume', dz ? U.n2(geo.zoneAcres * dz) + ' <small>acre-ft</small>' : '—', dz ? 'zone' : 'mute')
      ]));
      box.appendChild(c2);
    }

    if (RESULT && RESULT.ok) {
      var c3 = el('div', { class: 'pw-card' });
      c3.appendChild(el('h3', { text: 'Dosage' }));
      c3.appendChild(el('p', { class: 'pw-sub', text: RESULT.productName }));
      c3.appendChild(el('div', { class: 'pw-result' }, [
        el('div', {}, [
          el('div', { class: 'pw-lab', text: 'Estimated product required' }),
          el('div', { class: 'pw-amt', html: D.fmt(RESULT.amount) + ' <small>' + RESULT.unitAbbr + '</small>' })
        ])
      ]));
      if (RESULT.packaging.available) {
        c3.appendChild(el('div', { class: 'pw-metrics', style: 'margin-top:9px' }, [
          metric('Containers to buy', RESULT.packaging.count + ' <small>× ' + D.fmt(RESULT.packaging.containerSize) + ' ' + RESULT.packaging.unit + '</small>'),
          metric('Left over', D.fmt(RESULT.packaging.leftover) + ' <small>' + RESULT.packaging.unit + '</small>', 'mute')
        ]));
      }
      if (RESULT.clamps.length) {
        c3.appendChild(el('div', { class: 'pw-note pw-err', html: '<b>Capped at the label maximum</b>' + U.esc(RESULT.clamps[0].reason) }));
      }
      c3.appendChild(el('button', { class: 'pw-btn pw-sec pw-sm', type: 'button', style: 'margin-top:10px', onclick: function () { S.step = 9; goto('dose'); } }, ['See the calculation']));
      box.appendChild(c3);
    } else if (RESULT && RESULT.blocked) {
      var c4 = el('div', { class: 'pw-card' });
      c4.appendChild(el('h3', { text: 'Dosage' }));
      c4.appendChild(el('div', { class: 'pw-note pw-err', html: '<b>Cannot calculate</b>' + U.esc(RESULT.blocked) }));
      box.appendChild(c4);
    }
  }

  /* ---------------------------------------------------------------- report model */

  function buildReportModel() {
    var p = selectedProduct(), r = selectedRate();
    var depthZone = S.depthMode === 'zone' ? parseFloat(S.zoneDepthFt) || 0 : parseFloat(S.pondDepthFt) || 0;
    return {
      generatedAt: new Date(),
      pond: {
        name: S.pondName || 'Unnamed pond', property: S.property, address: S.address,
        accountName: S.accountId ? PW.store.accountName(S.accountId) : null,
        coords: S.coords
      },
      geo: geo, measures: M, state: S, product: p, rate: r, result: RESULT,
      depthZone: depthZone,
      staticMap: PW.map.staticUrl(S.coords, geo, PW.API_KEY, '660x400'),
      methodHtml: zoneMethodHtml(),
      user: PW.store.currentUser()
    };
  }

  /* ---------------------------------------------------------------- helpers */

  function metric(k, vHtml, cls) {
    return el('div', { class: U.cls('metric', cls) }, [
      el('span', { class: 'pw-k', html: k }),
      el('span', { class: 'pw-v', html: vHtml })
    ]);
  }

  function field(labelHtml, control) {
    var f = el('div', { class: 'pw-field' });
    f.appendChild(el('label', { class: 'pw-fl', html: labelHtml }));
    f.appendChild(control);
    return f;
  }

  function input(type, value, onInput, placeholder, opts) {
    opts = opts || {};
    var a = { type: type, value: value == null ? '' : value, placeholder: placeholder || '' };
    if (opts.min != null) a.min = opts.min;
    if (opts.step != null) a.step = opts.step;
    if (type === 'number') a.inputmode = 'decimal';
    if (opts.invalid) a['aria-invalid'] = 'true';
    var i = el('input', a);
    i.addEventListener('input', function () { onInput(this.value); });
    return i;
  }

  function select(options, value, onChange2) {
    var s = el('select', {});
    options.forEach(function (o) {
      s.appendChild(el('option', { value: o.v, selected: o.v === value }, [o.t]));
    });
    s.addEventListener('change', function () { onChange2(this.value); });
    return s;
  }

  function teardown() {
    S = blank(); geo = null; M = null; RESULT = null; host = {};
  }

  return {
    mount: mount, state: state, loadPond: loadPond, teardown: teardown,
    OBJECTIVES: OBJECTIVES, STEPS: STEPS
  };
})();


/* ==== 60-report.js ==== */
/* ============================================================
   PW.report — the treatment summary
   ------------------------------------------------------------
   One page, printable, exports to PDF through the browser print dialog.
   Everything on it is either a user input, a measured value, a label
   figure, or a stated assumption. Nothing is inferred silently.
   ============================================================ */
PW.report = (function () {
  'use strict';

  var U = PW.util, D = PW.dose, el = U.el;

  function html(m) {
    var g = m.geo, res = m.result, p = m.product, r = m.rate, S = m.state;
    var depthZone = m.depthZone;
    var zoneAcreFt = g.zoneAcres * depthZone;
    var pondAcreFt = g.pondAcres * (parseFloat(S.pondDepthFt) || 0);
    var pk = res.packaging;

    var out = [];
    out.push('<div class="pw-report" id="reportSheet">');

    /* ---- header ---- */
    out.push('<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:16px;flex-wrap:wrap">');
    out.push('<div><h1>' + U.esc(m.pond.name) + '</h1>');
    out.push('<div class="pw-rmeta">' +
      (m.pond.property ? U.esc(m.pond.property) + ' &middot; ' : '') +
      (m.pond.address ? U.esc(m.pond.address) : 'Location not recorded') +
      (m.pond.accountName ? ' &middot; ' + U.esc(m.pond.accountName) : '') + '</div>');
    out.push('<div class="pw-rmeta">Treatment summary prepared ' + U.esc(fullDate(m.generatedAt)) +
      ' by ' + U.esc(m.user.name) + ' (' + U.esc(PW.store.ROLE_LABEL[m.user.role] || m.user.role) + ')</div>');
    out.push('</div>');
    out.push('<div style="text-align:right"><div style="font-weight:750;color:#1b5233;letter-spacing:.3px">SePRO PondWise Planner</div>' +
      '<div class="pw-rmeta">Proof of concept ' + U.esc(PW.VERSION) + '</div></div>');
    out.push('</div>');

    /* ---- headline result ---- */
    out.push('<div class="pw-headline">');
    out.push('<div style="font-size:12px;text-transform:uppercase;letter-spacing:.6px;color:#4a5850;font-weight:650">Estimated product required</div>');
    out.push('<div class="pw-amt">' + D.fmt(res.amount) + ' <span style="font-size:17px">' + U.esc(res.unitAbbr) + '</span> ' +
      '<span style="font-size:15px;font-weight:600;color:#4a5850">of ' + U.esc(p.name) + '</span></div>');
    if (res.hasRange) {
      out.push('<div class="pw-rmeta">Labeled range for this measurement: ' + D.fmt(res.amountLow) + ' &ndash; ' +
        D.fmt(res.amountHigh) + ' ' + U.esc(res.unitAbbr) + '</div>');
    }
    if (pk.available) {
      out.push('<div class="pw-rmeta">Purchase ' + pk.count + ' &times; ' + D.fmt(pk.containerSize) + ' ' + U.esc(pk.unit) +
        ' container' + (pk.count === 1 ? '' : 's') + ' = ' + D.fmt(pk.purchaseAmount) + ' ' + U.esc(pk.unit) +
        ', leaving about ' + D.fmt(pk.leftover) + ' ' + U.esc(pk.unit) + ' unused.</div>');
    }
    out.push('</div>');

    if (res.mandatoryNote) {
      out.push('<div class="pw-note pw-err" style="margin-top:12px"><b>What this number is, and is not</b>' +
        U.esc(res.mandatoryNote) + '</div>');
    }

    /* ---- clamps and warnings, prominently ---- */
    res.clamps.forEach(function (c) {
      out.push('<div class="pw-note pw-err" style="margin-top:12px"><b>Reduced to the label maximum</b>' +
        'The ' + U.esc(c.what) + ' was reduced from ' + U.esc(c.from) + ' to ' + U.esc(c.to) +
        '. Label statement: &ldquo;' + U.esc(c.reason) + '&rdquo;</div>');
    });
    res.warnings.forEach(function (w) {
      out.push('<div class="pw-note pw-warn" style="margin-top:10px"><b>Check this</b>' + U.esc(w.text) + '</div>');
    });

    /* ---- map ---- */
    out.push('<section><h2>Mapped pond and treatment zone</h2>');
    if (m.staticMap) {
      out.push('<img class="pw-staticmap" alt="Satellite image of ' + U.esc(m.pond.name) +
        ' with the mapped pond boundary and treatment-zone overlay" src="' + U.esc(m.staticMap) + '">');
      out.push('<p class="pw-rmeta" style="margin-top:6px">Green outline: mapped pond boundary. ' +
        'Orange outline: inner edge of the treatment zone &mdash; the band between the two is the water being treated. ' +
        'Satellite imagery &copy; Google.</p>');
    } else {
      out.push('<p class="pw-rmeta">Satellite image unavailable.</p>');
    }
    if ((S.photos || []).length) {
      out.push('<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px">');
      S.photos.forEach(function (src) {
        out.push('<img src="' + U.esc(src) + '" alt="Site photo" style="width:150px;height:110px;object-fit:cover;border-radius:8px;border:1px solid #dfe5df">');
      });
      out.push('</div>');
    }
    out.push('</section>');

    /* ---- measurements ---- */
    out.push('<section><h2>Pond measurements</h2><div class="pw-kv">');
    kv(out, 'Total pond surface area', U.n0(g.pondSqft) + ' sq ft');
    kv(out, 'Total pond surface area', U.n2(g.pondAcres) + ' acres');
    kv(out, 'Shoreline perimeter', U.n0(g.perimeterFt) + ' ft');
    kv(out, 'Average pond depth (entered)', S.pondDepthFt ? U.n1(S.pondDepthFt) + ' ft' : 'not entered');
    kv(out, 'Estimated total pond volume', U.n2(pondAcreFt) + ' acre-feet');
    kv(out, 'Estimated total pond volume', U.n0(pondAcreFt * PW.geo.GAL_PER_ACREFT) + ' gallons');
    kv(out, 'Mapped boundary points', String(g.vertices));
    kv(out, 'Furthest open water from shore', U.n0(g.maxInscribedFt) + ' ft');
    out.push('</div></section>');

    /* ---- zone ---- */
    out.push('<section><h2>Treatment zone</h2><div class="pw-kv">');
    kv(out, 'Growth distance from shore (entered)', S.growthFt ? U.n0(S.growthFt) + ' ft' : 'not entered');
    kv(out, 'Treatment-zone surface area', U.n0(g.zoneSqft) + ' sq ft');
    kv(out, 'Treatment-zone surface area', U.n2(g.zoneAcres) + ' acres');
    kv(out, 'Share of pond surface treated', U.n1(g.zonePct) + ' %');
    kv(out, 'Depth used for the zone', depthZone ? U.n1(depthZone) + ' ft (' +
      (S.depthMode === 'zone' ? 'entered separately for the zone' : S.depthMode === 'product' ? 'per the product label' : 'pond average') + ')' : 'not entered');
    kv(out, 'Treatment-zone volume', U.n2(zoneAcreFt) + ' acre-feet');
    kv(out, 'Treatment-zone volume', U.n0(zoneAcreFt * PW.geo.GAL_PER_ACREFT) + ' gallons');
    kv(out, 'Untreated open water', U.n0(g.coreSqft) + ' sq ft');
    out.push('</div></section>');

    /* ---- product and calculation ---- */
    out.push('<section><h2>Product and dosage calculation</h2><div class="pw-kv">');
    kv(out, 'Selected growth category', D.OBJ_LABEL[S.objective] || S.objective);
    kv(out, 'Selected product', p.name);
    kv(out, 'Product category', p.category);
    kv(out, 'EPA registration number', p.epaReg || 'not stated on label');
    kv(out, 'Active ingredients', p.activeIngredients || '—');
    kv(out, 'Labeled use selected', r.label);
    if (res.concentration) {
      kv(out, 'Target ' + res.concentration.label, D.fmt(res.concentration.value) + ' ' + res.concentration.unit +
        ' (label range ' + D.fmt(res.concentration.min) + '–' + D.fmt(res.concentration.max) + ')');
    }
    kv(out, 'Application rate used', D.fmt(res.rateUsed) + ' ' + res.rateUnitText);
    if (res.hasRange) kv(out, 'Labeled rate range', D.fmt(res.rateLow) + ' – ' + D.fmt(res.rateHigh) + ' ' + res.rateUnitText);
    kv(out, 'Measurement the rate applies to', res.measure.meta.label + ' of the ' + res.measure.scopeLabel);
    kv(out, 'Measured value used', D.fmt(res.measure.value) + ' ' + res.measure.meta.unit);
    if (res.measure.depthLabel) kv(out, 'Depth basis', U.n1(res.measure.depthUsed) + ' ft — ' + res.measure.depthLabel);
    out.push('</div>');

    out.push('<div class="pw-calcbox" style="margin-top:12px"><div class="pw-calcline"><b>' +
      D.fmt(res.measure.value) + ' ' + U.esc(res.measure.meta.unit) + '</b> &times; <b>' +
      D.fmt(res.rateUsed) + ' ' + U.esc(res.rateUnitText) + '</b> = <b>' +
      D.fmt(res.amount) + ' ' + U.esc(res.unitAbbr) + '</b></div>');
    res.steps.forEach(function (st) {
      out.push('<div class="pw-rmeta" style="margin-top:5px">' + U.esc(st.text) + (st.note ? '<br><i>' + U.esc(st.note) + '</i>' : '') + '</div>');
    });
    out.push('</div>');

    /* purchase table */
    out.push('<table class="pw-t"><thead><tr><th>Quantity</th><th class="pw-n">Amount</th></tr></thead><tbody>');
    row(out, 'Exact calculated quantity', D.fmt(res.amount) + ' ' + res.unitAbbr);
    if (res.hasRange) {
      row(out, 'At the label minimum rate', D.fmt(res.amountLow) + ' ' + res.unitAbbr);
      row(out, 'At the maximum labeled rate', D.fmt(res.amountHigh) + ' ' + res.unitAbbr);
    }
    if (pk.available) {
      row(out, 'Container size', D.fmt(pk.containerSize) + ' ' + pk.unit);
      row(out, 'Number of containers required', String(pk.count));
      row(out, 'Recommended purchase quantity', D.fmt(pk.purchaseAmount) + ' ' + pk.unit);
      row(out, 'Estimated unused product remaining', D.fmt(pk.leftover) + ' ' + pk.unit);
    } else {
      row(out, 'Container count', 'not available — ' + (pk.reason || 'no container size'));
    }
    out.push('</tbody></table>');

    (res.season || []).forEach(function (s) {
      out.push('<div class="pw-note pw-info" style="margin-top:10px"><b>Season budget for this pond</b>' + U.esc(s.text) +
        '<br>For the area mapped that is about ' + D.fmt(s.budget) + ' ' + U.esc(s.unit) +
        ' for the season. This application uses ' + D.fmt(s.usedByThis) + ' ' + U.esc(s.unit) +
        ' (' + U.n1(s.pctOfBudget) + '%).</div>');
    });
    out.push('</section>');

    /* ---- restrictions ---- */
    out.push('<section><h2>Application notes and restrictions</h2>');
    if (p.adjuvantRequirement) {
      out.push('<div class="pw-note pw-err"><b>Adjuvant / surfactant requirement</b>' + U.esc(p.adjuvantRequirement) + '</div>');
    }
    var rest = p.restrictions || {};
    var rows = [];
    [['potable', 'Potable / drinking water'], ['irrigation', 'Irrigation'], ['livestock', 'Livestock watering'],
    ['swimming', 'Swimming'], ['fishing_fish_consumption', 'Fishing / fish consumption'], ['other', 'Other']]
      .forEach(function (k) { if (rest[k[0]]) rows.push([k[1], rest[k[0]]]); });
    if (rows.length) {
      out.push('<table class="pw-t"><thead><tr><th>Water use</th><th>Label restriction</th></tr></thead><tbody>');
      rows.forEach(function (rr) {
        out.push('<tr><td style="white-space:nowrap;vertical-align:top;font-weight:650">' + U.esc(rr[0]) +
          '</td><td class="pw-fine">' + U.esc(rr[1]) + '</td></tr>');
      });
      out.push('</tbody></table>');
    }
    if (p.retreatmentInterval) out.push('<p class="pw-fine"><b>Retreatment interval:</b> ' + U.esc(p.retreatmentInterval) + '</p>');
    if (p.partialTreatmentRule) out.push('<p class="pw-fine"><b>Partial treatment:</b> ' + U.esc(p.partialTreatmentRule) + '</p>');
    if (p.depthLimits) out.push('<p class="pw-fine"><b>Depth limits:</b> ' + U.esc(p.depthLimits) + '</p>');
    if ((p.hardMaximums || []).length) {
      out.push('<p class="pw-fine" style="margin-bottom:2px"><b>Maximum rates and &ldquo;do not exceed&rdquo; statements on this label:</b></p><ul class="pw-fine">');
      p.hardMaximums.forEach(function (h) { out.push('<li>' + U.esc(h) + '</li>'); });
      out.push('</ul>');
    }
    if ((p.requiredNotes || []).length) {
      out.push('<p class="pw-fine" style="margin-bottom:2px"><b>Required application notes:</b></p><ul class="pw-fine">');
      p.requiredNotes.forEach(function (n) { out.push('<li>' + U.esc(n) + '</li>'); });
      out.push('</ul>');
    }
    out.push('</section>');

    /* ---- method and assumptions ---- */
    out.push('<section><h2>Calculation method and assumptions</h2>');
    out.push('<div class="pw-fine">' + m.methodHtml + '</div>');
    out.push('<p class="pw-fine" style="margin-bottom:2px"><b>Every figure in this summary is an estimate. It depends on:</b></p><ul class="pw-fine">');
    [
      'the accuracy of the shoreline as it was traced on the satellite image (' + g.vertices + ' points placed)',
      'the age, resolution and water level of the available satellite imagery',
      'the user-entered average pond depth of ' + (S.pondDepthFt ? U.n1(S.pondDepthFt) + ' ft' : 'not entered'),
      'the user-entered aquatic growth distance from shore of ' + (S.growthFt ? U.n0(S.growthFt) + ' ft' : 'not entered') +
      ', treated as a single average around the whole shoreline',
      'the depth used for the treatment zone (' + (depthZone ? U.n1(depthZone) + ' ft, ' +
        (S.depthMode === 'zone' ? 'entered separately' : S.depthMode === 'product' ? 'per the product label' : 'the pond average') : 'not entered') + ')',
      'the application rate selected within the labeled range (' + D.fmt(res.rateUsed) + ' ' + res.rateUnitText + ')',
      'the assumption that the treatment zone is a uniform band of the entered width inward from the mapped shoreline'
    ].forEach(function (a) { out.push('<li>' + a + '</li>'); });
    out.push('</ul>');
    if (S.depthMode === 'pond') {
      out.push('<p class="pw-fine"><b>Note on depth:</b> the pond average depth was applied to the shoreline treatment zone. ' +
        'Aquatic growth was not assumed to occupy a shallower band. Shoreline water is usually shallower than the pond average, ' +
        'so this is likely to overstate the treated volume, and with it any volume-based dose.</p>');
    }
    if ((p.dataGaps || []).length) {
      out.push('<p class="pw-fine" style="margin-bottom:2px"><b>What this product label does not provide:</b></p><ul class="pw-fine">');
      p.dataGaps.forEach(function (dg) { out.push('<li>' + U.esc(dg) + '</li>'); });
      out.push('</ul>');
    }
    out.push('</section>');

    if (S.notes) {
      out.push('<section><h2>Notes</h2><p class="pw-fine" style="white-space:pre-wrap">' + U.esc(S.notes) + '</p></section>');
    }

    /* ---- disclaimer ---- */
    out.push('<section><h2>Product label disclaimer</h2><div class="pw-disclaim">' +
      '<b>Read and follow the current product label.</b> The label is the law. It is a violation of Federal law to use any of these products ' +
      'in a manner inconsistent with its labeling. This summary is a planning estimate produced from a proof-of-concept calculator and from ' +
      'the label document named below; it does not replace the current product label, the product\'s Safety Data Sheet, or the judgement of a ' +
      'qualified aquatic-management professional. Confirm every rate, restriction, waiting period and setback against the label in your hand ' +
      'before mixing or applying anything, and confirm whether a state, tribal or local permit is required for the waterbody you are treating.' +
      '<br><br>Label referenced for this calculation: <b>' + U.esc(p.labelFile || 'not recorded') + '</b>' +
      (p.epaReg ? ' (' + U.esc(p.epaReg) + ')' : '') + '.' +
      '<br>Questions on rates or program design: contact a SePRO Aquatic Specialist.' +
      '</div></section>');

    out.push('<p class="pw-rmeta" style="margin-top:18px;text-align:center">Generated by SePRO PondWise Planner ' +
      U.esc(PW.VERSION) + ' &middot; ' + U.esc(fullDate(m.generatedAt)) + '</p>');
    out.push('</div>');
    return out.join('');
  }

  function kv(out, k, v) {
    out.push('<div><span>' + U.esc(k) + '</span><span>' + U.esc(v) + '</span></div>');
  }
  function row(out, k, v) {
    out.push('<tr><td>' + U.esc(k) + '</td><td class="pw-n">' + U.esc(v) + '</td></tr>');
  }
  function fullDate(d) {
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
      'August', 'September', 'October', 'November', 'December'];
    return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear() + ' at ' +
      d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  }

  return { html: html };
})();


/* ==== 70-views.js ==== */
/* ============================================================
   PW.ui — app shell, router, saved ponds, dashboard, glossary, report view
   ============================================================ */
PW.ui = (function () {
  'use strict';

  var U = PW.util, D = PW.dose, el = U.el;
  var PRODUCTS = [];
  var root, mainEl, navEl, whoEl;
  var view = 'planner';
  var plannerMounted = false, plannerHost = null;

  /* ---------------------------------------------------------------- shell */

  /**
   * boot(products, initialView)
   * initialView defaults to the planner. When the Maps API is unavailable the
   * caller passes 'products', because mounting the planner would need Maps.
   */
  function boot(products, initialView) {
    PRODUCTS = products;
    // PW.rootEl is set by whichever entry point is in use — the standalone
    // page or the Shopify section. Falling back to #app keeps the plain page
    // working with no configuration.
    root = PW.rootEl || document.getElementById('app');
    PW.rootEl = root;
    if (root.className.indexOf('pw-root') < 0) root.className += 'pw-root';

    root.appendChild(topbar());
    root.appendChild(labelBar());
    mainEl = el('div', { class: 'pw-wrap' });
    root.appendChild(mainEl);

    plannerHost = el('div', {});

    go(initialView || 'planner');
  }

  function topbar() {
    var t = el('div', { class: 'pw-topbar' });
    var b = el('div', { class: 'pw-brand' });
    b.innerHTML =
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M3 15c2.5-2 4.5-2 7 0s4.5 2 7 0 2.5-2 4 0" stroke="#8fd4a8" stroke-width="1.8" stroke-linecap="round"/>' +
      '<path d="M3 19c2.5-2 4.5-2 7 0s4.5 2 7 0 2.5-2 4 0" stroke="#4aa3df" stroke-width="1.8" stroke-linecap="round"/>' +
      '<path d="M12 3c2.6 2.6 4 4.7 4 6.6a4 4 0 1 1-8 0C8 7.7 9.4 5.6 12 3Z" fill="#8fd4a8"/></svg>' +
      '<span>SePRO PondWise Planner<small>Next-generation pond treatment planner &middot; proof of concept</small></span>';
    t.appendChild(b);

    navEl = el('div', { class: 'pw-nav' });
    t.appendChild(navEl);

    whoEl = el('div', { class: 'pw-whoami' });
    t.appendChild(whoEl);
    renderWho();
    renderNav();
    return t;
  }

  function renderNav() {
    var n = U.clear(navEl);
    var items = [['planner', 'Planner'], ['ponds', 'Saved ponds']];
    var mapsReady = PW.mapsReady !== false;
    if (PW.store.canSeeDashboard()) items.push(['dashboard', 'Dashboard']);
    items.push(['products', 'Product library']);
    items.forEach(function (it) {
      var needsMap = (it[0] === 'planner');
      n.appendChild(el('button', {
        type: 'button', 'aria-current': view === it[0] ? 'page' : null,
        title: needsMap && !mapsReady ? 'The planner needs the satellite map, which could not load' : null,
        style: needsMap && !mapsReady ? 'opacity:.5' : null,
        onclick: function () { go(it[0]); }
      }, [it[1]]));
    });
  }

  function renderWho() {
    var w = U.clear(whoEl);
    var u = PW.store.currentUser();
    if (!PW.store.demoRolesVisible()) {
      // On a live storefront the signed-in customer is the identity, so there
      // is nothing to switch between.
      w.appendChild(el('span', { text: u.name + ' — ' + (PW.store.ROLE_LABEL[u.role] || u.role) }));
      return w;
    }
    w.appendChild(el('span', { text: 'Signed in as' }));
    var s = el('select', { 'aria-label': 'Demo role and user switcher' });
    PW.store.users().forEach(function (x) {
      s.appendChild(el('option', { value: x.id, selected: x.id === u.id },
        [x.name + ' — ' + (PW.store.ROLE_LABEL[x.role] || x.role)]));
    });
    s.addEventListener('change', function () {
      PW.store.setCurrentUser(this.value);
      renderWho(); renderNav();
      if (view !== 'planner') go(view); else go('planner');
    });
    w.appendChild(s);
    return w;
  }

  function labelBar() {
    var d = el('div', { class: 'pw-labelbar' });
    d.appendChild(el('div', {
      html: '<b>Every result in this tool is an estimate.</b> Read and follow the current product label before mixing or applying anything — ' +
        'the label is the law, and it overrides anything shown here. This calculator does not replace the label or the advice of a qualified ' +
        'aquatic-management professional. Check whether a permit is required for your waterbody.'
    }));
    d.appendChild(el('button', { type: 'button', onclick: openGlossary }, ['Glossary']));
    return d;
  }

  function go(v) {
    view = v;
    renderNav();
    U.clear(mainEl);
    if (v === 'planner') {
      if (PW.mapsReady === false) {
        // Never mount the planner without Maps — PW.planner.mount would throw
        // and take the whole shell down with it.
        mainEl.appendChild(el('div', { class: 'pw-card' }, [
          el('h3', { text: 'The planner needs the satellite map' }),
          el('div', {
            class: 'pw-note pw-err',
            html: 'Google Maps did not load, so the pond cannot be mapped. The problem and how to fix it are ' +
              'described on the Product library page, which still works because it reads the label data ' +
              'straight out of this file.'
          }),
          el('div', { class: 'pw-btnrow' }, [
            el('button', { class: 'pw-btn', type: 'button', onclick: function () { go('products'); } }, ['See the problem and the fix']),
            el('button', { class: 'pw-btn pw-ghost', type: 'button', onclick: function () { location.reload(); } }, ['Retry'])
          ])
        ]));
      } else {
        mainEl.appendChild(plannerHost);
        if (!plannerMounted) { PW.planner.mount(plannerHost, PRODUCTS); plannerMounted = true; }
      }
    } else if (v === 'ponds') mainEl.appendChild(pondsView());
    else if (v === 'dashboard') mainEl.appendChild(dashboardView());
    else if (v === 'products') mainEl.appendChild(productsView());
    window.scrollTo(0, 0);
  }

  /* ---------------------------------------------------------------- saved ponds */

  function pondsView() {
    var wrap = el('div', {});
    var u = PW.store.currentUser();
    var ponds = PW.store.visiblePonds(u);

    var head = el('div', { class: 'pw-card' });
    head.appendChild(el('h3', { text: 'Saved ponds' }));
    head.appendChild(el('p', {
      class: 'pw-sub',
      html: 'You are seeing <b>' + ponds.length + '</b> pond' + (ponds.length === 1 ? '' : 's') +
        ' across <b>' + PW.store.visibleAccountIds(u).length + '</b> account' + (PW.store.visibleAccountIds(u).length === 1 ? '' : 's') +
        '. ' + scopeSentence(u)
    }));
    if (!PW.store.isPersistent()) {
      head.appendChild(el('div', { class: 'pw-note pw-warn', html: '<b>Local storage is unavailable in this browser</b>Saved ponds and calculations will not survive a page reload here. In a production build this data would live in the customer-account system rather than the browser.' }));
    }
    wrap.appendChild(head);

    if (!ponds.length) {
      wrap.appendChild(el('div', { class: 'pw-card' }, [
        el('div', { class: 'pw-empty', text: 'No saved ponds for this account yet. Map one in the Planner and save it.' })
      ]));
      return wrap;
    }

    var grid = el('div', { class: 'pw-grid-cards' });
    grid.style.marginTop = '14px';
    ponds.forEach(function (p) {
      var calcs = PW.store.calcsForPond(p.id);
      var c = el('div', { class: 'pw-card' });
      if (p.photos && p.photos.length) c.appendChild(el('img', { class: 'pw-thumb', src: p.photos[0], alt: '' }));
      c.appendChild(el('h3', { text: p.name || 'Unnamed pond' }));
      c.appendChild(el('div', { class: 'pw-pondmeta', text: [p.property, p.address].filter(Boolean).join(' · ') || 'No location recorded' }));
      c.appendChild(el('div', { class: 'pw-pondmeta', text: PW.store.accountName(p.accountId) + ' · added ' + U.prettyDate(p.createdAt) }));
      c.appendChild(el('div', { class: 'pw-metrics', style: 'margin-top:10px' }, [
        metric('Boundary points', String((p.coords || []).length)),
        metric('Average depth', p.depthFt ? U.n1(p.depthFt) + ' <small>ft</small>' : '— <small>not recorded</small>', p.depthFt ? '' : 'mute'),
        metric('Calculations', String(calcs.length))
      ]));
      if (calcs.length) {
        var t = el('table', { class: 'pw-t' });
        t.innerHTML = '<thead><tr><th>Date</th><th>Product</th><th class="pw-n">Amount</th></tr></thead>';
        var tb = el('tbody');
        calcs.slice(0, 4).forEach(function (cc) {
          tb.appendChild(el('tr', {}, [
            el('td', { text: U.prettyDate(cc.date) }),
            el('td', { text: cc.productName || cc.productId }),
            el('td', { class: 'pw-n', text: D.fmt(cc.amount) + ' ' + D.unitAbbr(cc.unit) })
          ]));
        });
        t.appendChild(tb);
        c.appendChild(el('div', { style: 'margin-top:6px' }, [
          el('div', { class: 'pw-pondmeta', text: 'Treatment history' }), t
        ]));
      }
      if (p.notes) c.appendChild(el('p', { class: 'pw-hint', text: p.notes }));
      c.appendChild(el('div', { class: 'pw-btnrow' }, [
        el('button', {
          class: 'pw-btn pw-sm', type: 'button', onclick: function () {
            PW.planner.loadPond(p); go('planner');
          }
        }, ['Open in planner']),
        el('button', {
          class: 'pw-btn pw-danger pw-sm', type: 'button', onclick: function () {
            if (window.confirm('Delete “' + (p.name || 'this pond') + '” and its ' + calcs.length + ' saved calculation(s)?')) {
              PW.store.deletePond(p.id); go('ponds');
            }
          }
        }, ['Delete'])
      ]));
      grid.appendChild(c);
    });
    wrap.appendChild(grid);
    return wrap;
  }

  function scopeSentence(u) {
    if (u.role === 'customer') return 'As a customer you only see ponds and calculations on your own account.';
    if (u.role === 'specialist') return 'As a Technical Specialist you see the customer accounts assigned to you.';
    return 'As Sales & Marketing management you see every account.';
  }

  /* ---------------------------------------------------------------- dashboard */

  function dashboardView() {
    var wrap = el('div', {});
    var u = PW.store.currentUser();
    var allPonds = PW.store.visiblePonds(u);
    var allCalcs = PW.store.visibleCalcs(u);

    var F = dashboardView.filters || { region: '', accountId: '', specialistId: '', objective: '', productId: '', from: '', to: '' };
    dashboardView.filters = F;

    /* -- filter bar -- */
    var fc = el('div', { class: 'pw-card' });
    fc.appendChild(el('h3', { text: 'Dashboard' }));
    fc.appendChild(el('p', { class: 'pw-sub', html: scopeSentence(u) + ' Totals below respect both your access scope and the filters.' }));

    var accounts = PW.store.accounts().filter(function (a) { return PW.store.visibleAccountIds(u).indexOf(a.id) >= 0; });
    var regions = uniq(accounts.map(function (a) { return a.region; }));
    var specialists = uniq(accounts.map(function (a) { return a.specialistId; }));
    var prodIds = uniq(allCalcs.map(function (c) { return c.productId; }));

    var bar = el('div', { class: 'pw-filters' });
    bar.appendChild(sel('Region', regions.map(function (r) { return { v: r, t: r }; }), F.region, function (v) { F.region = v; go('dashboard'); }));
    bar.appendChild(sel('Customer account', accounts.map(function (a) { return { v: a.id, t: a.name }; }), F.accountId, function (v) { F.accountId = v; go('dashboard'); }));
    bar.appendChild(sel('Technical Specialist', specialists.map(function (s) { return { v: s, t: PW.store.specialistName(s) }; }), F.specialistId, function (v) { F.specialistId = v; go('dashboard'); }));
    bar.appendChild(sel('Treatment category', Object.keys(D.OBJ_LABEL).map(function (k) { return { v: k, t: D.OBJ_LABEL[k] }; }), F.objective, function (v) { F.objective = v; go('dashboard'); }));
    bar.appendChild(sel('Product', prodIds.map(function (id) {
      var p = PRODUCTS.filter(function (x) { return x.id === id; })[0];
      return { v: id, t: p ? p.name : id };
    }), F.productId, function (v) { F.productId = v; go('dashboard'); }));
    bar.appendChild(dateField('From', F.from, function (v) { F.from = v; go('dashboard'); }));
    bar.appendChild(dateField('To', F.to, function (v) { F.to = v; go('dashboard'); }));
    fc.appendChild(bar);
    fc.appendChild(el('div', { class: 'pw-btnrow' }, [
      el('button', {
        class: 'pw-btn pw-ghost pw-sm', type: 'button', onclick: function () {
          dashboardView.filters = { region: '', accountId: '', specialistId: '', objective: '', productId: '', from: '', to: '' };
          go('dashboard');
        }
      }, ['Clear filters'])
    ]));
    wrap.appendChild(fc);

    /* -- apply filters -- */
    function acctOK(id) {
      var a = PW.store.accountOf(id);
      if (!a) return false;
      if (F.region && a.region !== F.region) return false;
      if (F.accountId && a.id !== F.accountId) return false;
      if (F.specialistId && a.specialistId !== F.specialistId) return false;
      return true;
    }
    var ponds = allPonds.filter(function (p) { return acctOK(p.accountId); });
    var calcs = allCalcs.filter(function (c) {
      if (!acctOK(c.accountId)) return false;
      if (F.objective && c.objective !== F.objective) return false;
      if (F.productId && c.productId !== F.productId) return false;
      if (F.from && (c.date || '') < F.from) return false;
      if (F.to && (c.date || '') > F.to) return false;
      return true;
    });
    var pondIdsWithCalcs = uniq(calcs.map(function (c) { return c.pondId; }));

    /* -- KPIs -- */
    var mappedAcres = 0;
    ponds.forEach(function (p) { mappedAcres += pondAcresOf(p); });
    var treatedAcres = 0;
    calcs.forEach(function (c) { treatedAcres += (c.zoneAcres || 0); });

    var k = el('div', { class: 'pw-kpis' });
    k.style.marginTop = '14px';
    k.appendChild(kpi('Mapped ponds', U.n0(ponds.length), pondIdsWithCalcs.length + ' with calculations'));
    k.appendChild(kpi('Total mapped water', U.n2(mappedAcres) + ' ac', 'surface acres across the filtered ponds'));
    k.appendChild(kpi('Total calculated treatment area', U.n2(treatedAcres) + ' ac', 'summed across ' + calcs.length + ' calculation' + (calcs.length === 1 ? '' : 's')));
    k.appendChild(kpi('Calculations', U.n0(calcs.length), 'matching the current filters'));
    wrap.appendChild(k);

    /* -- product quantities -- */
    var byProd = {};
    calcs.forEach(function (c) {
      var key = c.productId + '|' + c.unit;
      byProd[key] = byProd[key] || { productId: c.productId, name: c.productName || c.productId, unit: c.unit, amount: 0, n: 0 };
      byProd[key].amount += (c.amount || 0);
      byProd[key].n++;
    });
    var prodRows = Object.keys(byProd).map(function (kk) { return byProd[kk]; })
      .sort(function (a, b) { return b.amount - a.amount; });

    var c1 = el('div', { class: 'pw-card' });
    c1.appendChild(el('h3', { text: 'Product quantities included in calculations' }));
    c1.appendChild(el('p', { class: 'pw-sub', text: 'These are planning figures from saved calculations, not orders or applications.' }));
    if (!prodRows.length) c1.appendChild(el('div', { class: 'pw-empty', text: 'No calculations match the current filters.' }));
    else {
      var t = el('table', { class: 'pw-t' });
      t.innerHTML = '<thead><tr><th>Product</th><th class="pw-n">Calculations</th><th class="pw-n">Total quantity</th></tr></thead>';
      var tb = el('tbody');
      prodRows.forEach(function (r) {
        tb.appendChild(el('tr', {}, [
          el('td', { text: r.name }),
          el('td', { class: 'pw-n', text: String(r.n) }),
          el('td', { class: 'pw-n', text: D.fmt(r.amount) + ' ' + D.unitAbbr(r.unit) })
        ]));
      });
      t.appendChild(tb); c1.appendChild(t);
    }
    wrap.appendChild(c1);

    /* -- categories -- */
    var byObj = {};
    calcs.forEach(function (c) { byObj[c.objective] = (byObj[c.objective] || 0) + 1; });
    var objRows = Object.keys(byObj).sort(function (a, b) { return byObj[b] - byObj[a]; });
    var c2 = el('div', { class: 'pw-card' });
    c2.appendChild(el('h3', { text: 'Treatment categories selected' }));
    if (!objRows.length) c2.appendChild(el('div', { class: 'pw-empty', text: 'No calculations match the current filters.' }));
    else objRows.forEach(function (o) {
      var pct = calcs.length ? byObj[o] / calcs.length * 100 : 0;
      var row = el('div', { style: 'margin-top:9px' });
      row.appendChild(el('div', { style: 'display:flex;justify-content:space-between;font-size:13px' }, [
        el('span', { text: D.OBJ_LABEL[o] || o }),
        el('b', { text: byObj[o] + ' (' + U.n0(pct) + '%)' })
      ]));
      var bar2 = el('div', { class: 'pw-bar' });
      bar2.appendChild(el('i', { style: 'width:' + pct.toFixed(1) + '%' }));
      row.appendChild(bar2);
      c2.appendChild(row);
    });
    wrap.appendChild(c2);

    /* -- recent -- */
    var c3 = el('div', { class: 'pw-card' });
    c3.appendChild(el('h3', { text: 'Recently created calculations' }));
    var recent = calcs.slice().sort(function (a, b) { return (b.date || '').localeCompare(a.date || ''); }).slice(0, 12);
    if (!recent.length) c3.appendChild(el('div', { class: 'pw-empty', text: 'Nothing yet.' }));
    else {
      var t3 = el('table', { class: 'pw-t' });
      t3.innerHTML = '<thead><tr><th>Date</th><th>Account</th><th>Pond</th><th>Category</th><th>Product</th>' +
        '<th class="pw-n">Zone acres</th><th class="pw-n">Amount</th></tr></thead>';
      var tb3 = el('tbody');
      recent.forEach(function (c) {
        var p = PW.store.pond(c.pondId);
        tb3.appendChild(el('tr', {}, [
          el('td', { text: U.prettyDate(c.date) }),
          el('td', { text: PW.store.accountName(c.accountId) }),
          el('td', { text: p ? p.name : '—' }),
          el('td', { text: D.OBJ_LABEL[c.objective] || c.objective }),
          el('td', { text: c.productName || c.productId }),
          el('td', { class: 'pw-n', text: U.n2(c.zoneAcres || 0) }),
          el('td', { class: 'pw-n', text: D.fmt(c.amount) + ' ' + D.unitAbbr(c.unit) })
        ]));
      });
      t3.appendChild(tb3); c3.appendChild(t3);
    }
    wrap.appendChild(c3);

    return wrap;
  }

  function pondAcresOf(p) {
    if (!p.coords || p.coords.length < 3) return 0;
    try { return PW.geo.areaSqft(p.coords) / PW.geo.SQFT_PER_ACRE; } catch (e) { return 0; }
  }

  function uniq(a) {
    var seen = {}, out = [];
    a.forEach(function (x) { if (x != null && x !== '' && !seen[x]) { seen[x] = 1; out.push(x); } });
    return out;
  }

  function sel(label, opts, value, onChange) {
    var f = el('div', { class: 'pw-field' });
    f.appendChild(el('label', { class: 'pw-fl', text: label }));
    var s = el('select', {});
    s.appendChild(el('option', { value: '' }, ['All']));
    opts.forEach(function (o) { s.appendChild(el('option', { value: o.v, selected: o.v === value }, [o.t])); });
    s.addEventListener('change', function () { onChange(this.value); });
    f.appendChild(s);
    return f;
  }

  function dateField(label, value, onChange) {
    var f = el('div', { class: 'pw-field' });
    f.appendChild(el('label', { class: 'pw-fl', text: label }));
    var i = el('input', { type: 'date', value: value || '' });
    i.addEventListener('change', function () { onChange(this.value); });
    f.appendChild(i);
    return f;
  }

  function kpi(k, v, d) {
    return el('div', { class: 'pw-kpi' }, [
      el('div', { class: 'pw-k', text: k }),
      el('div', { class: 'pw-v', text: v }),
      el('div', { class: 'pw-d', text: d || '' })
    ]);
  }

  function metric(k, vHtml, cls) {
    return el('div', { class: U.cls('metric', cls) }, [
      el('span', { class: 'pw-k', html: k }),
      el('span', { class: 'pw-v', html: vHtml })
    ]);
  }

  /* ---------------------------------------------------------------- product library */

  function productsView() {
    var wrap = el('div', {});
    var head = el('div', { class: 'pw-card' });
    head.appendChild(el('h3', { text: 'Product library' }));
    var nRates = PRODUCTS.reduce(function (a, p) { return a + p.rates.length; }, 0);
    var nBlocked = PRODUCTS.reduce(function (a, p) {
      return a + p.rates.filter(function (r) { return r.calculable === false; }).length;
    }, 0);
    head.appendChild(el('p', {
      class: 'pw-sub',
      html: '<b>' + PRODUCTS.length + '</b> products and <b>' + nRates + '</b> labeled rate scenarios, read from the ' +
        PRODUCTS.length + ' label PDFs in this project. ' + nBlocked + ' of those rates cannot be calculated from label data alone ' +
        'and are marked as such rather than being estimated. Adding a product means adding a record here — the calculator does not change.'
    }));
    var q = el('input', { type: 'search', placeholder: 'Filter by product, active ingredient or target species…' });
    head.appendChild(el('div', { class: 'pw-field' }, [q]));
    wrap.appendChild(head);

    var list = el('div', {});
    list.style.marginTop = '14px';
    wrap.appendChild(list);

    function draw() {
      var term = q.value.trim().toLowerCase();
      U.clear(list);
      var shown = PRODUCTS.filter(function (p) {
        if (!term) return true;
        return (p.name + ' ' + p.category + ' ' + (p.activeIngredients || '') + ' ' +
          (p.targetSpecies || []).join(' ')).toLowerCase().indexOf(term) >= 0;
      });
      if (!shown.length) { list.appendChild(el('div', { class: 'pw-card' }, [el('div', { class: 'pw-empty', text: 'No products match that filter.' })])); return; }
      shown.forEach(function (p) {
        var c = el('div', { class: 'pw-card' });
        c.appendChild(el('h3', { text: p.name }));
        c.appendChild(el('p', { class: 'pw-sub', text: p.category + (p.epaReg ? ' · ' + p.epaReg : '') + ' · ' + (p.formulation || '') }));
        var chips = el('div', { class: 'pw-chips' });
        (p.objectives || []).forEach(function (o) { chips.appendChild(el('span', { class: 'pw-chip', text: D.OBJ_LABEL[o] || o })); });
        if (!p.isPesticide) chips.appendChild(el('span', { class: 'pw-chip pw-grey', text: 'not a pesticide — dye / shading agent' }));
        if (p.adjuvantRequirement) chips.appendChild(el('span', { class: 'pw-chip pw-red', text: 'adjuvant required' }));
        if ((p.packages || []).length) chips.appendChild(el('span', { class: 'pw-chip pw-grey', text: 'label states package size' }));
        c.appendChild(chips);

        var t = el('table', { class: 'pw-t' });
        t.innerHTML = '<thead><tr><th>Labeled use</th><th>Objective</th><th>Basis</th><th class="pw-n">Rate</th><th>Applied to</th></tr></thead>';
        var tb = el('tbody');
        p.rates.forEach(function (r) {
          var meta = D.MEASURE_META[r.measure] || {};
          var rateTxt;
          if (r.calculable === false) rateTxt = 'not calculable';
          else if (r.concentration) rateTxt = D.fmt(r.min) + '–' + D.fmt(Math.min(r.max != null ? r.max : Infinity, r.concentration.labelMaxConc != null ? r.concentration.labelMaxConc : Infinity)) + ' ' + r.concentration.concUnit;
          else if (r.min != null && r.max != null && Math.abs(r.max - r.min) > 1e-9) rateTxt = D.fmt(r.min) + '–' + D.fmt(r.max) + ' ' + D.unitAbbr(r.unit);
          else rateTxt = D.fmt(r.max != null ? r.max : r.typical) + ' ' + D.unitAbbr(r.unit);
          tb.appendChild(el('tr', {}, [
            el('td', { text: r.label }),
            el('td', { text: D.OBJ_LABEL[r.objective] || r.objective }),
            el('td', { text: String(r.basis).replace(/_/g, ' ') }),
            el('td', { class: 'pw-n', text: rateTxt }),
            el('td', { text: meta.label || r.measure })
          ]));
        });
        t.appendChild(tb);
        c.appendChild(t);

        if ((p.caps || []).length) {
          var d1 = el('details', { class: 'pw-disc' });
          d1.appendChild(el('summary', { text: 'Ceilings the calculator enforces (' + p.caps.length + ')' }));
          var b1 = el('div', { class: 'pw-body' });
          var u1 = el('ul');
          p.caps.forEach(function (cp) {
            u1.appendChild(el('li', { text: cp.text + '  [' + D.fmt(cp.max) + ' ' + D.unitAbbr(cp.unit) + ' ' + cp.basis.replace(/_/g, ' ') + ', per ' + cp.scope + ']' }));
          });
          b1.appendChild(u1); d1.appendChild(b1); c.appendChild(d1);
        }
        if ((p.dataGaps || []).length) {
          var d2 = el('details', { class: 'pw-disc' });
          d2.appendChild(el('summary', { text: 'What this label does not provide (' + p.dataGaps.length + ')' }));
          var b2 = el('div', { class: 'pw-body' });
          var u2 = el('ul');
          p.dataGaps.forEach(function (g) { u2.appendChild(el('li', { text: g })); });
          b2.appendChild(u2); d2.appendChild(b2); c.appendChild(d2);
        }
        list.appendChild(c);
      });
    }
    q.addEventListener('input', U.debounce(draw, 140));
    draw();
    return wrap;
  }

  /* ---------------------------------------------------------------- modals */

  function modal(title, bodyNode) {
    // Overlays go on <body> so no theme wrapper can clip them, and they carry
    // the scope class themselves so the scoped stylesheet still applies.
    var m = el('div', { class: 'pw-root pw-modal' });
    var box = el('div', { class: 'pw-box' });
    box.appendChild(el('button', { class: 'pw-x', type: 'button', 'aria-label': 'Close', onclick: close }, ['×']));
    box.appendChild(el('h2', { text: title }));
    box.appendChild(bodyNode);
    m.appendChild(box);
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    function esc(e) { if (e.key === 'Escape') close(); }
    function close() { document.removeEventListener('keydown', esc); m.remove(); }
    document.addEventListener('keydown', esc);
    document.body.appendChild(m);
    return { close: close };
  }

  function openGlossary() {
    var b = el('div', {});
    b.appendChild(el('p', { class: 'pw-sub', text: 'Plain-language definitions of the terms this planner uses.' }));
    Object.keys(U.GLOSSARY).forEach(function (k) {
      b.appendChild(el('h4', { text: titleCase(k), style: 'margin-top:14px;font-size:14px' }));
      b.appendChild(el('p', { style: 'margin:3px 0 0;font-size:13.5px;color:var(--ink-2)', text: U.GLOSSARY[k] }));
    });
    b.appendChild(el('div', { class: 'pw-note pw-info', html: '<b>A worked example</b>A one-acre pond averaging 5 ft deep holds 5 acre-feet, about 1.63 million gallons. ' +
      'If growth reaches 15 ft out from a 900 ft shoreline, the treatment band is roughly 0.28 acres — around 28% of the pond surface. ' +
      'At 5 ft that band is about 1.4 acre-feet. A product rated at 2 gal per acre-foot would therefore need about 2.8 gallons.' }));
    modal('Glossary', b);
  }

  function titleCase(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function showReport(model) {
    U.clear(mainEl);
    var bar = el('div', { class: 'pw-noprint', style: 'display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px' });
    bar.appendChild(el('button', { class: 'pw-btn', type: 'button', onclick: function () { window.print(); } }, ['Print / save as PDF']));
    bar.appendChild(el('button', { class: 'pw-btn pw-sec', type: 'button', onclick: function () { go('planner'); } }, ['Back to planner']));
    bar.appendChild(el('button', {
      class: 'pw-btn pw-ghost', type: 'button', onclick: function () {
        var t = document.getElementById('reportSheet');
        if (!t) return;
        navigator.clipboard && navigator.clipboard.writeText(t.innerText).then(function () {
          bar.lastChild.textContent = 'Copied';
          setTimeout(function () { bar.lastChild.textContent = 'Copy as text'; }, 1600);
        });
      }
    }, ['Copy as text']));
    mainEl.appendChild(bar);
    var sheet = el('div', { html: PW.report.html(model) });
    mainEl.appendChild(sheet);
    window.scrollTo(0, 0);
  }

  /** Insert a node at the top of the current view (used by the key diagnosis). */
  function prependNotice(node) {
    if (!mainEl) return false;
    mainEl.insertBefore(node, mainEl.firstChild);
    return true;
  }

  /** Reset the shell so a Shopify section rebuild can re-init cleanly. */
  function teardown() {
    plannerMounted = false;
    plannerHost = null;
    mainEl = null;
    view = 'planner';
    if (PW.map && PW.map.teardown) PW.map.teardown();
    if (PW.planner && PW.planner.teardown) PW.planner.teardown();
  }

  return {
    boot: boot, go: go, openGlossary: openGlossary, showReport: showReport,
    modal: modal, prependNotice: prependNotice, teardown: teardown
  };
})();


/* ==== 85-diag.js ==== */
/* ============================================================
   PW.diag — Google Maps API key diagnosis
   ------------------------------------------------------------
   When the Maps API refuses a key it paints its own grey "See the JavaScript
   console for technical details" panel and logs a specific error code. Users
   should not have to open devtools to find out what is wrong, so this module
   captures that code, translates it into the actual fix, and lets a working
   key be pasted in without rebuilding the file.
   ============================================================ */
PW.diag = (function () {
  'use strict';

  var KEY_STORE = 'pondwise.apikey';
  var captured = null;          // the Maps error code, once we see it
  var authFailed = false;

  /* Every documented Maps JS auth/config failure, with the fix rather than a
     restatement of the symptom. */
  var CODES = {
    RefererNotAllowedMapError: {
      title: 'The key does not allow the address this page is being served from',
      fix: 'The key has an HTTP-referrer restriction and this page is not on the list. This is the usual ' +
        'cause when a key that works on the live site fails locally — a page opened straight from disk ' +
        '(a file:// address) sends no referrer at all, so it can never match. Either serve the file over ' +
        'http and add that address to the key\'s allowed referrers, or use a key with no referrer restriction ' +
        'for development.',
      likelyLocal: true
    },
    ApiNotActivatedMapError: {
      title: 'The Maps JavaScript API is not enabled on the key\'s Cloud project',
      fix: 'Enable the Maps JavaScript API in Google Cloud Console under APIs & Services → Library. ' +
        'This planner also needs the Geocoding API (address search), the Places API (address suggestions) ' +
        'and the Maps Static API (the satellite image in the printed summary).'
    },
    ApiTargetBlockedMapError: {
      title: 'The key is restricted to a set of APIs that excludes the Maps JavaScript API',
      fix: 'In Google Cloud Console open the key → API restrictions, and add the Maps JavaScript API, ' +
        'Geocoding API, Places API and Maps Static API to the allowed list.'
    },
    BillingNotEnabledMapError: {
      title: 'The key\'s Cloud project has no billing account attached',
      fix: 'The Maps JavaScript API requires billing even inside the monthly free allowance. Attach a ' +
        'billing account to the project in Google Cloud Console.'
    },
    InvalidKeyMapError: {
      title: 'Google does not recognise this key',
      fix: 'The key is malformed, was deleted, or belongs to a different project. Paste a current key below.'
    },
    MissingKeyMapError: {
      title: 'No API key was supplied',
      fix: 'Paste a key below.'
    },
    ExpiredKeyMapError: {
      title: 'The key has expired',
      fix: 'Issue a new key in Google Cloud Console and paste it below.'
    },
    OverQuotaMapError: {
      title: 'The key is over its quota',
      fix: 'Check quotas and billing for the project in Google Cloud Console. If a daily cap is set, raise it.'
    },
    DeletedApiProjectMapError: {
      title: 'The key\'s Cloud project has been deleted',
      fix: 'Use a key from an active project.'
    },
    NotLoadingAPIFromGoogleMapsError: {
      title: 'The Maps API was not loaded from a Google domain',
      fix: 'Something is intercepting or proxying the API script — a corporate proxy, an ad blocker or a ' +
        'content filter. Try a different network or browser profile.'
    }
  };

  /* ---------------------------------------------------------------- key */

  function storedKey() {
    try { return window.localStorage.getItem(KEY_STORE) || null; } catch (e) { return null; }
  }
  function keyInUse() { return storedKey() || PW.API_KEY_BUILTIN; }
  function usingOwnKey() { return !!storedKey(); }
  function setKey(k) {
    try { window.localStorage.setItem(KEY_STORE, String(k).trim()); return true; }
    catch (e) { return false; }
  }
  function clearKey() {
    try { window.localStorage.removeItem(KEY_STORE); return true; } catch (e) { return false; }
  }
  function mask(k) {
    if (!k) return '(none)';
    return k.length <= 12 ? k : k.slice(0, 8) + '…' + k.slice(-4);
  }

  /* ---------------------------------------------------------------- capture */

  function install() {
    // Google reports auth failures through this global.
    var prev = window.gm_authFailure;
    window.gm_authFailure = function () {
      authFailed = true;
      if (typeof prev === 'function') { try { prev(); } catch (e) { } }
      if (PW.diag.onProblem) PW.diag.onProblem(captured, true);
    };

    // The specific code only appears in a console.error, so read it there.
    var realError = window.console && window.console.error;
    if (realError) {
      window.console.error = function () {
        try {
          var txt = Array.prototype.map.call(arguments, String).join(' ');
          var m = txt.match(/\b([A-Za-z]+MapError|[A-Za-z]*MapsApiError)\b/);
          if (m && !captured) {
            captured = m[1];
            if (PW.diag.onProblem) PW.diag.onProblem(captured, authFailed);
          }
        } catch (e) { /* never let diagnosis break logging */ }
        return realError.apply(window.console, arguments);
      };
    }
  }

  function code() { return captured; }
  function didAuthFail() { return authFailed; }

  function isFileUrl() { return String(location.protocol) === 'file:'; }

  /* ---------------------------------------------------------------- panel */

  /**
   * Build the diagnosis card. Returns a DOM node.
   *   onRetry — called after a key is saved, so the caller can reload.
   */
  function panel(opts) {
    opts = opts || {};
    var U = PW.util, el = U.el;
    var c = CODES[captured] || null;

    var card = el('div', { class: 'pw-card' });
    card.appendChild(el('h3', { text: c ? c.title : 'Google Maps rejected the request' }));

    if (captured) {
      card.appendChild(el('p', { class: 'pw-sub', html: 'Google reported <code>' + U.esc(captured) + '</code>.' }));
    } else if (authFailed) {
      card.appendChild(el('p', { class: 'pw-sub', text: 'Google rejected the API key but did not report a specific code.' }));
    } else {
      card.appendChild(el('p', { class: 'pw-sub', text: 'The Maps script loaded but never finished initialising.' }));
    }

    card.appendChild(el('div', { class: 'pw-note pw-err', html: c ? U.esc(c.fix)
      : 'The most common causes are, in order: the key is restricted to particular web addresses and this ' +
        'page is not one of them; the Maps JavaScript API is not enabled on the key\'s project; or the ' +
        'project has no billing account. The exact code is in the browser console.' }));

    // The single most likely cause when running the file locally.
    if (isFileUrl() && (!c || c.likelyLocal || !captured)) {
      card.appendChild(el('div', {
        class: 'pw-note pw-warn',
        html: '<b>This page is open directly from disk</b>The address bar starts with <code>file://</code>. ' +
          'A key with any HTTP-referrer restriction — which is normal for a key used on a live site — can ' +
          'never match a file:// page, because the browser sends no referrer. Serving the folder over http ' +
          'is usually the whole fix:<br><br>' +
          '<code style="display:block;padding:8px;background:#fff;border-radius:6px;margin:6px 0">' +
          'cd &lt;folder containing this file&gt;<br>python3 -m http.server 8000</code>' +
          'then open <code>http://localhost:8000/PondWise-Planner.html</code> and add ' +
          '<code>http://localhost:8000/*</code> to the key\'s allowed referrers in Google Cloud Console.'
      }));
    }

    /* which APIs this tool needs */
    var d = el('details', { class: 'pw-disc' });
    d.appendChild(el('summary', { text: 'The four APIs this planner needs enabled' }));
    var b = el('div', { class: 'pw-body' });
    var ul = el('ul');
    [
      ['Maps JavaScript API', 'the satellite map and the editable pond outline — nothing works without it'],
      ['Geocoding API', 'turning a typed address into a location'],
      ['Places API', 'the address suggestions as you type; the planner still works without it'],
      ['Maps Static API', 'the satellite image embedded in the printed treatment summary']
    ].forEach(function (r) {
      ul.appendChild(el('li', {}, [el('b', { text: r[0] }), ' — ' + r[1]]));
    });
    b.appendChild(ul);
    b.appendChild(el('p', { text: 'All four must be both enabled on the project and permitted by the key\'s own API restrictions. Those are two separate settings and it is easy to do one and not the other.' }));
    d.appendChild(b);
    card.appendChild(d);

    /* key override */
    var kb = el('div', { style: 'margin-top:14px;border-top:1px solid var(--line-2);padding-top:13px' });
    kb.appendChild(el('h4', { text: 'Try a different key', style: 'font-size:14px' }));
    kb.appendChild(el('p', {
      class: 'pw-hint',
      html: 'Currently using ' + (usingOwnKey() ? 'a key you entered' : 'the key built into this file') +
        ': <code>' + U.esc(mask(keyInUse())) + '</code>. A key entered here is kept in this browser only and ' +
        'overrides the built-in one — no rebuild needed.'
    }));
    var input = el('input', { type: 'text', placeholder: 'Paste a Google Maps API key', style: 'margin-top:8px' });
    kb.appendChild(input);
    var msg = el('div', {});
    var row = el('div', { class: 'pw-btnrow' });
    row.appendChild(el('button', {
      class: 'pw-btn', type: 'button', onclick: function () {
        var v = input.value.trim();
        if (!v) { note('warn', 'Paste a key first.'); return; }
        if (!/^AIza[0-9A-Za-z_\-]{20,}$/.test(v)) {
          note('warn', 'That does not look like a Google API key — they start with “AIza”. Saving it anyway; if it fails you will land back here.');
        }
        if (!setKey(v)) { note('err', 'This browser is blocking local storage, so the key cannot be saved here. Serve the file over http, or edit PW.API_KEY_BUILTIN in the file.'); return; }
        location.reload();
      }
    }, ['Save key and reload']));
    if (usingOwnKey()) {
      row.appendChild(el('button', {
        class: 'pw-btn pw-ghost', type: 'button', onclick: function () { clearKey(); location.reload(); }
      }, ['Revert to the built-in key']));
    }
    row.appendChild(el('button', {
      class: 'pw-btn pw-ghost', type: 'button', onclick: function () { location.reload(); }
    }, ['Retry']));
    kb.appendChild(row);
    kb.appendChild(msg);
    card.appendChild(kb);

    function note(kind, text) {
      PW.util.clear(msg);
      msg.appendChild(el('div', { class: U.cls('note', kind), text: text }));
    }

    card.appendChild(el('p', {
      class: 'pw-hint', style: 'margin-top:12px',
      html: 'The product library still works — it reads the label data straight out of this file and needs no network at all.'
    }));

    return card;
  }

  return {
    install: install, panel: panel, code: code, didAuthFail: didAuthFail,
    keyInUse: keyInUse, usingOwnKey: usingOwnKey, setKey: setKey, clearKey: clearKey,
    isFileUrl: isFileUrl, CODES: CODES,
    onProblem: null
  };
})();


/* ==== shopify.js ==== */
/* ============================================================
   Shopify entry point
   ------------------------------------------------------------
   The section markup hands us a config blob. From it we get the API key, the
   map defaults, the signed-in customer (if any) and the merchant's mapping
   from PondWise product ids to Shopify products — which is where container
   sizes come from for the 23 of 28 labels that state no net contents.

   Section lifecycle: the theme editor tears a section down and rebuilds it on
   every settings change, so init/destroy must be idempotent. Only one instance
   per page is supported; a second one says so rather than half working.
   ============================================================ */
(function () {
  'use strict';

  var MONEY = function (cents) {
    if (cents == null) return '';
    var s = (cents / 100).toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  PW.shop = {
    config: null,
    map: {},                  // pondwise product id -> shopify product info
    activeSectionId: null,

    /** Pack size for a PondWise product, if the merchant configured one. */
    packFor: function (productId, unit) {
      var e = PW.shop.map[productId];
      if (!e || !e.containerSize || e.containerSize <= 0) return null;
      if (unit && e.containerUnit && e.containerUnit !== unit) return null;
      return {
        size: e.containerSize,
        unit: e.containerUnit || unit,
        label: 'pack size set in the theme for ' + (e.title || 'this product'),
        variantId: e.variantId,
        available: e.available,
        url: e.url,
        title: e.title,
        price: e.price
      };
    },

    /** The linked Shopify product for a PondWise product, if any. */
    linkFor: function (productId) { return PW.shop.map[productId] || null; },

    /** Add a quantity of the linked variant to the cart. */
    addToCart: function (productId, qty, cb) {
      var e = PW.shop.map[productId];
      if (!e || !e.variantId) { cb({ ok: false, error: 'unlinked' }); return; }
      if (!e.available) { cb({ ok: false, error: 'unavailable' }); return; }
      var n = Math.max(1, parseInt(qty, 10) || 1);
      fetch(PW.shop.rootUrl('/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(e.variantId), quantity: n }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error((j && j.description) || 'Cart rejected the item'); });
        return r.json();
      }).then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        cb({ ok: true, qty: n, title: e.title });
      }).catch(function (err) {
        cb({ ok: false, error: String(err && err.message ? err.message : err) });
      });
    },

    rootUrl: function (p) {
      var base = (PW.shop.config && PW.shop.config.routes && PW.shop.config.routes.cartAdd) || null;
      if (p === '/cart/add.js' && base) return base;
      var r = (PW.shop.config && PW.shop.config.rootUrl) || '/';
      if (r.charAt(r.length - 1) === '/') r = r.slice(0, -1);
      return r + p;
    },

    money: MONEY
  };

  /* ---------------------------------------------------------------- roles */

  /**
   * On a storefront the signed-in customer is the identity. Role comes from
   * customer tags so the merchant controls it from the Shopify admin without
   * a separate user table:
   *   pondwise-sales       -> Sales & Marketing management (sees everything)
   *   pondwise-specialist  -> Technical Specialist
   *   anything else        -> Customer (their own account only)
   */
  function applyCustomer(cfg) {
    if (!cfg.customer || !cfg.customer.id) return;
    var tags = (cfg.customer.tags || []).map(function (t) { return String(t).toLowerCase(); });
    var role = tags.indexOf('pondwise-sales') >= 0 ? 'sales'
      : tags.indexOf('pondwise-specialist') >= 0 ? 'specialist' : 'customer';
    PW.store.registerShopifyCustomer({
      id: 'shopify-' + cfg.customer.id,
      name: cfg.customer.name || cfg.customer.email || 'Customer',
      email: cfg.customer.email || '',
      role: role,
      accountName: cfg.customer.company || cfg.customer.name || cfg.customer.email || 'My account'
    });
  }

  /* ---------------------------------------------------------------- init */

  var booted = false;

  function readConfig(sectionEl) {
    var node = sectionEl.querySelector('[data-pw-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function readProductMap(sectionEl) {
    var node = sectionEl.querySelector('[data-pw-products-map]');
    if (!node) return {};
    try { return JSON.parse(node.textContent) || {}; } catch (e) { return {}; }
  }

  function showMessage(host, title, body, kind) {
    host.className = 'pw-root';
    host.innerHTML = '<div class="pw-wrap"><div class="pw-card"><h3>' + title + '</h3>' +
      '<div class="' + PW.util.cls('note', kind || 'err') + '">' + body + '</div></div></div>';
  }

  function init(sectionEl) {
    var host = sectionEl.querySelector('[data-pw-root]');
    if (!host) return;

    var cfg = readConfig(sectionEl);
    if (!cfg) {
      showMessage(host, 'Configuration missing',
        'The section could not read its settings. Re-save the section in the theme editor.');
      return;
    }

    // Claimed synchronously, because booting is async: a second section on the
    // page reaches init() long before the first has finished loading products.
    if (PW.shop.activeSectionId && PW.shop.activeSectionId !== cfg.sectionId) {
      showMessage(host, 'Only one PondWise Planner per page',
        'This proof of concept keeps one map, one pond and one calculation in memory, so a second ' +
        'planner on the same page would share state with the first. Remove one of them, or put them on ' +
        'separate pages.', 'warn');
      return;
    }

    PW.shop.config = cfg;
    PW.shop.map = readProductMap(sectionEl);
    PW.shop.activeSectionId = cfg.sectionId;

    PW.rootEl = host;
    PW.API_KEY_BUILTIN = cfg.apiKey || '';
    PW.mapDefaults = {
      center: { lat: parseFloat(cfg.defaultLat) || 39.8283, lng: parseFloat(cfg.defaultLng) || -98.5795 },
      zoom: parseInt(cfg.defaultZoom, 10) || 5
    };

    PW.diag.install();
    PW.API_KEY = PW.diag.keyInUse();
    PW.dose.setPackSource(PW.shop.packFor);

    if (cfg.showDemoRoles === false) PW.store.hideDemoRoles();
    applyCustomer(cfg);

    var products = window.PW_PRODUCTS_INLINE || null;

    function go(list) {
      PW.PRODUCTS = list;
      loadMaps(function (ok) {
        if (!ok) { keyProblem(list); return; }
        PW.mapsReady = true;
        try {
          PW.ui.boot(list);
          booted = true;
        } catch (e) {
          showMessage(host, 'The planner failed to start',
            '<b>Google Maps loaded, but the planner threw an error:</b> ' +
            String(e && e.message ? e.message : e) +
            '<br><br>This is a fault in the planner, not in the API key. The stack trace is in the browser console.');
          throw e;
        }
      });
    }

    function keyProblem(list) {
      PW.mapsReady = false;
      host.innerHTML = '';
      try {
        PW.PRODUCTS = list || [];
        PW.ui.boot(PW.PRODUCTS, 'products');
        PW.ui.prependNotice(PW.diag.panel());
      } catch (e) {
        showMessage(host, 'Google Maps could not be loaded',
          'The map is unavailable and the label library could not be rendered either. ' +
          'The browser console has the details.');
      }
    }
    PW.diag.onProblem = function () { keyProblem(PW.PRODUCTS || []); };

    if (products) { go(products); return; }

    // The product database lives in theme assets so it is CDN-cached rather
    // than re-rendered into every page view.
    showMessage(host, 'Loading the product library…',
      'Reading the label data for 28 products.', 'info');
    fetch(cfg.productsUrl, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (list) {
        if (!Array.isArray(list) || !list.length) throw new Error('empty product file');
        window.PW_PRODUCTS_INLINE = list;
        host.innerHTML = '';
        go(list);
      })
      .catch(function (err) {
        showMessage(host, 'The product library could not be loaded',
          '<b>' + String(err && err.message ? err.message : err) + '</b>' +
          'The planner reads its label data from <code>pondwise-products.json</code> in the theme assets. ' +
          'Check that the file was uploaded to <b>Assets</b> and that the section setting ' +
          '<b>Product data file</b> matches its name. Expected at:<br><code>' +
          String(cfg.productsUrl || '(not set)') + '</code>');
      });
  }

  /* ---------------------------------------------------------------- maps loader */

  var mapsState = 'idle';     // idle | loading | ready | failed
  var mapsWaiters = [];

  function libsPresent() {
    return !!(window.google && google.maps && google.maps.geometry &&
      google.maps.geometry.spherical && google.maps.MVCArray);
  }

  function loadMaps(cb) {
    if (mapsState === 'ready' || libsPresent()) { mapsState = 'ready'; cb(true); return; }
    if (mapsState === 'failed') { cb(false); return; }
    mapsWaiters.push(cb);
    if (mapsState === 'loading') return;
    mapsState = 'loading';

    if (!PW.API_KEY) { settle(false); return; }

    window.__pwMapsReady = function () { settle(libsPresent()); };

    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(PW.API_KEY) +
      '&libraries=geometry,places&loading=async&callback=__pwMapsReady';
    s.async = true;
    s.setAttribute('data-pondwise-maps', 'true');
    s.onerror = function () { settle(false); };
    document.head.appendChild(s);

    setTimeout(function () { if (mapsState === 'loading') settle(false); }, 12000);
  }

  function settle(ok) {
    mapsState = ok ? 'ready' : 'failed';
    var w = mapsWaiters.slice();
    mapsWaiters = [];
    w.forEach(function (f) { try { f(ok); } catch (e) { } });
  }

  /* ---------------------------------------------------------------- lifecycle */

  function destroy(sectionEl) {
    var cfg = readConfig(sectionEl);
    if (cfg && PW.shop.activeSectionId === cfg.sectionId) {
      PW.shop.activeSectionId = null;
      booted = false;
      if (PW.ui && PW.ui.teardown) PW.ui.teardown();
    }
  }

  function boot() {
    var els = document.querySelectorAll('[data-pondwise-section]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: sections are rebuilt on every settings change.
  document.addEventListener('shopify:section:load', function (ev) {
    var el = ev.target && ev.target.querySelector
      ? (ev.target.matches && ev.target.matches('[data-pondwise-section]')
        ? ev.target : ev.target.querySelector('[data-pondwise-section]'))
      : null;
    if (el) { booted = false; PW.shop.activeSectionId = null; if (PW.ui && PW.ui.teardown) PW.ui.teardown(); init(el); }
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var el = ev.target && ev.target.querySelector
      ? (ev.target.matches && ev.target.matches('[data-pondwise-section]')
        ? ev.target : ev.target.querySelector('[data-pondwise-section]'))
      : null;
    if (el) destroy(el);
  });
})();
